/*if(navigator.appVersion.indexOf("MSIE")>-1 || navigator.appVersion.indexOf("Edge")>-1 || navigator.appVersion.indexOf("Trident")>-1){
    alert('IE');
}
else{
	alert('No IE');
    (function($) {
        $('a[href^=mailto]').each(function() {
            var href = $(this).attr('href');
            $(this).click(function() {
                var t;
                var self = $(this);

                $(window).blur(function() {
                    // The browser apparently responded, so stop the timeout.
                    clearTimeout(t);
                });

                t = setTimeout(function() {
                    // The browser did not respond after 500ms, so open an alternative URL.
                    alert('Kein Mailclient');
                }, 500);
            });
        });
    })(jQuery);
}*/
(function ($) {
	$('a[href^=mailto]').each(function () {
		var href = $(this).attr('href');
		$(this).click(function () {
			var t;
			var self = $(this);

			$(window).blur(function () {
				// The browser apparently responded, so stop the timeout.
				clearTimeout(t);
			});

			t = setTimeout(function () {
				// The browser did not respond after 500ms, so open an alternative URL.
				alert('Um die Funktion "Per E-Mail teilen" zu nutzen, benötigen Sie ein Mail-Programm auf Ihrem Rechner.');
			}, 2500);
		});
	});

	const vorstands = document.querySelectorAll('.vorstand');
	if (!vorstands.length) {
		console.log('No .vorstand elements found.');
		return;
	}

	// --- RESET ---
	vorstands.forEach(v => {
		v.style.height = 'auto';
		v.style.display = '';
		v.style.flexDirection = '';
	});

	document.querySelectorAll('.vorstand .vorstand__position, .vorstand .vorstand__name, .vorstand .person_details, .vorstand .person_decription')
		.forEach(el => {
			el.style.minHeight = '';
			el.style.flexGrow = '';
			el.style.marginTop = '';
		});

	// --- STEP 1: Equalize .vorstand height ---
	let maxHeight = 0;
	vorstands.forEach(v => {
		const h = v.offsetHeight;
		if (h > maxHeight) maxHeight = h;
	});
	vorstands.forEach(v => v.style.height = maxHeight + 'px');

	// --- STEP 2: Flex structure for internal alignment ---
	vorstands.forEach(v => {
		v.style.display = 'flex';
		v.style.flexDirection = 'column';
	});

	// Let content flow naturally
	document.querySelectorAll('.vorstand .person_details').forEach(el => {
		el.style.flex = '1 1 auto';
	});

	// Keep bottom icons fixed
	document.querySelectorAll('.vorstand .person_decription').forEach(el => {
		el.style.marginTop = 'auto';
	});

	// --- STEP 3: Average-based balanced spacing with soft padding ---
	const nameEls = [...document.querySelectorAll('.vorstand .vorstand__name')];
	const posEls = [...document.querySelectorAll('.vorstand .vorstand__position')];

	const avg = list => list.reduce((a, el) => a + el.offsetHeight, 0) / list.length;

	const avgName = avg(nameEls);
	const avgPos = avg(posEls);

	// Add small padding buffer for shorter ones
	const extraPadding = 6; // adjust this value for slightly more or less spacing

	nameEls.forEach(el => {
		if (el.offsetHeight < avgName) {
			el.style.minHeight = avgName + extraPadding + 'px';
		}
	});

	posEls.forEach(el => {
		if (el.offsetHeight < avgPos) {
			el.style.minHeight = avgPos + extraPadding + 'px';
		}
	});
})(jQuery);

// global scope object cache
glob = {};

// global settings & vars
// -----------------------------------------------------------------------------------------------------------------
glob = {};
glob.doc = $(document);
glob.win = $(window);
glob.winW = glob.win.width();
glob.winH = glob.win.height();
glob.docH = 0;
glob.articles = 0;

// backward compatibility ie flags
glob.ie = false;
glob.ieVersion = 1000;
for (var i = 8; i <= 10; i++) {
	if (navigator.appVersion.indexOf("MSIE " + i) != -1) {
		glob.ie = true;
		glob['ie' + i] = true;
		glob.ieVersion = i;
	}
}
// ie 11
if (navigator.userAgent.match(/Trident.*rv[ :]*11\./)) {
	glob.ie = true;
	glob.ie11 = true;
	glob.ieVersion = 11;
}
if (navigator.userAgent.match(/Edge/)) {
	glob.ie = true;
	glob.ieEdge = true;
}


/**
 * global resizing, gets triggered before all other resizing stuff
 * use customResize event in all other bindings!
 */
glob.win.resize(function () {
	glob.winW = glob.win.width();
	glob.winH = glob.win.height();
	glob.docH = glob.doc.height();

	glob.win.trigger('customResize', {
		width: glob.winW,
		height: glob.winH,
		docHeight: glob.docH
	});
});

glob.enableDebug = true;
glob.debug = function ($content) {
	if (!glob.enableDebug) return;
	if (typeof console !== 'object') return;
	if (console.log) console.log($content);
};

glob.scrollTo = function ($target, $offset, $easing) {
	$offset = $offset || 40;
	$easing = $easing || 'easeInOutCubic';
	glob.scrollTarget.stop(true).animate(
		{
			scrollTop: $target.offset().top - $offset
		},
		{
			duration: 1300,
			easing: $easing
		}
	)
};

glob.scrollToY = function ($y) {
	glob.scrollTarget.stop(true).animate(
		{
			scrollTop: $y
		},
		{
			duration: 1300,
			easing: 'easeInOutCubic'
		}
	)
};

// user agent settings
// -----------------------------------------------------------------------------------------------------------------

glob.ie8 = navigator.appVersion.indexOf("MSIE 8") != -1;
glob.ie9 = navigator.appVersion.indexOf("MSIE 9") != -1;

//msGesture = window.navigator && window.navigator.msPointerEnabled && window.MSGesture;
//glob.touch = ("ontouchstart" in window) || window.DocumentTouch && document instanceof DocumentTouch;

glob.ie11 = !!window.MSInputMethodContext && !glob.touch;

function getUrlParameter(sParam) {
	var sPageURL = window.location.search.substring(1);
	var sURLVariables = sPageURL.split('&');
	for (var i = 0; i < sURLVariables.length; i++) {
		var sParameterName = sURLVariables[i].split('=');
		if (sParameterName[0] == sParam) {
			return sParameterName[1];
		}
	}
	return '';
}

//var debugMSPhone = false;

function colFilterTabel(filter) {

	var dataTable = $('#tda2017_list').DataTable();
	var header = dataTable.columns().header();
	var colArray = [0];
	var associates = [];

	switch (filter) {
		case 'all':
			associates = [];
			dataTable.columns().visible().each(function (vis, i) {
				if (!vis) {
					colArray.push(i);
				}
			});

			header.each(function (val, col) {
				var ass = $(val).attr('data-ass');

				if (ass) {
					dataTable.rows().every(function (row) {
						var cell = $(dataTable.cell(row, col).node());
						if (cell.attr('data-content')) {
							cell.html(cell.attr('data-content'));
							cell.removeAttr('data-content');
						}
					});

				}
			});
			break;
		case 'none':
			break;

		case 'booklet':
			associates = [];
			header.each(function (val, col) {

				var fil = $(val).attr('data-filter');
				var ass = $(val).attr('data-ass');

				if (fil && fil.search('engineer') != -1) {

					associates[ass] = [];

					dataTable.rows().every(function (row) {
						var value = $(dataTable.cell(row, col).node()).html();
						if (value && value === 'Ja') {
							associates[ass].push(row);
						}
					});

				}
			});
		default:
			header.each(function (val, col) {
				var fil = $(val).attr('data-filter');
				var ass = $(val).attr('data-ass');

				if (fil) {

					if (fil.search(filter) != -1) {
						colArray.push(col);
					}
				}
				if (ass && filter === 'booklet') {

					associates[ass].forEach(function (row) {
						var cell = $(dataTable.cell(row, col).node());
						cell.attr('data-content', cell.html());
						cell.html('');
					});
				}
			});


	}

	if (filter === 'booklet') {
		associates.forEach(function (data) {

		})
	}
	if (filter != 'all') {
		var hideArray = [];
		dataTable.columns().visible().each(function (vis, i) {
			if (vis) {
				hideArray.push(i);
			}
		});
		dataTable.columns(hideArray).visible(false);
	}

	dataTable.columns(colArray).visible(true);
}

(function (window, document, $) {
	'use strict';

	/**
	 * Global variables
	 */
	var
		Cookies,
		App,
		OSM,
		FUF,
		TDA,
		EventHandling,
		TimePicker,
		DateTimePicker,
		BootstrapFileInput,
		BootstrapTable,
		ProjectHandling,
		FormHandling,
		PopupLink,
		SideBar,
		BrowserHandling,
		UserSearchForm,
		SearchHandling,
		BookmarkHandling,
		Cookieman,
		select2,
		Accordion,
		VerticalCol,
		Vorstand,
		SaturdayOrSunday,
		Tags;

	/**
	 * Document Ready Calls
	 */
	$(document).ready(function () {
		// var glob = {};
		glob.winH = $(window).height();
		glob.isFortbildung = glob.isVeranstaltung = glob.isAip = glob.isNotNews = false;
		if ($('#breadcrumb').text().indexOf('Fortbildung') >= 0) glob.isFortbildung = true;
		if ($('#breadcrumb').text().indexOf('Veranstaltungen') >= 0) glob.isVeranstaltung = true;
		if ($('#breadcrumb').text().indexOf('AiP-Seminare') >= 0) glob.isAip = true;
		if (glob.isFortbildung || glob.isVeranstaltung || glob.isAip) glob.isNotNews = true;

		App.init();
		FUF.init();
		EventHandling.init();
		FormHandling.init();
		DateTimePicker.init();
		BootstrapFileInput.init();
		BootstrapTable.init();
		ProjectHandling.init();
		PopupLink.init();
		PopupLink.event();
		BrowserHandling.init();
		SideBar.init();
		SearchHandling.init();
		UserSearchForm.init();
		BookmarkHandling.init();
		Cookieman.init();
		select2.init();
		TDA.init();
		Accordion.init();
		VerticalCol.init();
		Vorstand.init();
		SaturdayOrSunday.init();
	});

	Vorstand = {
		init: function () {
			//close popup
			$('.cd-popup').on('click', function(event){
				if( $(event.target).is('.cd-popup-close') || $(event.target).is('.cd-popup') ) {
					event.preventDefault();
					$(this).removeClass('is-visible');
				}
			});
			//close popup when clicking the esc keyboard button
			$(document).keyup(function(event){
				if(event.which=='27'){
					$('.cd-popup').removeClass('is-visible');
				}
			});
			$('.open-popup-link').click(function (e){
				var id = ($(this)[0].getAttribute('href'));
				Vorstand.openpopup(id,e);

			});
		},
			//open popup
		openpopup: function (id,e) {
			e.preventDefault();
			$(id).addClass('is-visible');
		}
	};

	SaturdayOrSunday = {
		init: function () {
			$('select[id^="appointmentSaturdayTo-"]').on('change', function(e) {
				$('select[id^="appointmentSaturdayFrom-"]').trigger('change');
			});
			$('select[id^="appointmentSundayTo-"]').on('change', function(e) {
				$('select[id^="appointmentSundayFrom-"]').trigger('change');
			});
			$('select[id^="appointmentSaturdayFrom-"]').on('change', function(e) {
				var $select = $('select[id^="appointmentSundayFrom-"]');
				var $select2 = $('select[id^="appointmentSundayTo-"]');

				if($(this).val()== -1) {
					/*var arr = $('select[id^="appointmentSundayFrom-"] option');
					for(var i=0; i<arr.length; i++) {
						if(arr[i] && (arr[i].text == 'geschlossen')) {
							arr[i].remove();
						}
					}
					var arr2 = $('select[id^="appointmentSundayTo-"] option');
					for(var j=0; j<arr2.length; j++) {
						if(arr2[j] && (arr2[j].text == 'geschlossen')) {
							arr2[j].remove();
						}
					}*/
				}
				else {
					var arr = $('select[id^="appointmentSundayFrom-"]');
					var opt = 'geschlossen';
					if (!($('select[id^="appointmentSundayFrom-"] option:contains('+ opt +')').length)) {
						arr.prepend(new Option('geschlossen','-1'));
					}
					var arr2 = $('select[id^="appointmentSundayTo-"]');
					if (!($('select[id^="appointmentSundayTo-"] option:contains('+ opt +')').length)) {
						arr2.prepend(new Option('geschlossen','-1'));
					}
				}
				$select.trigger("chosen:updated");
				$select2.trigger("chosen:updated");
			});
			$('select[id^="appointmentSundayFrom-"]').on('change', function() {
				var $select = $('select[id^="appointmentSaturdayFrom-"]');
				var $select2 = $('select[id^="appointmentSaturdayTo-"]');

				if($(this).val()== -1) {
					/*var arr = $('select[id^="appointmentSaturdayFrom-"] option');
					for(var i=0; i<arr.length; i++) {
						if(arr[i] && (arr[i].text == 'geschlossen')) {
							arr[i].remove();
						}
					}

					var arr2 = $('select[id^="appointmentSaturdayTo-"] option');
					for(var j=0; j<arr2.length; j++) {
						if(arr2[j] && (arr2[j].text == 'geschlossen')) {
							arr2[j].remove();
						}
					}*/
				}
				else {
					var arr = $('select[id^="appointmentSaturdayFrom-"]');
					var opt = 'geschlossen';
					if (!($('select[id^="appointmentSaturdayFrom-"] option:contains('+ opt +')').length)) {
						arr.prepend(new Option('geschlossen','-1'));
					}
					var arr2 = $('select[id^="appointmentSaturdayTo-"]');
					if (!($('select[id^="appointmentSaturdayTo-"] option:contains('+ opt +')').length)) {
						arr2.prepend(new Option('geschlossen','-1'));
					}
				}
				$select.trigger("chosen:updated");
				$select2.trigger("chosen:updated");
			});
		}
	};

	Accordion = {
		init: function () {
			if($('.accordion .panel-group .panel-default .panel-heading ul')) {
				$('.accordion .panel-group .panel-default .panel-heading ul').parent().parent().parent().siblings('.panel-collapse').find('.panel-body').css({
					'padding': '0 0 0 40px ',
				})

			}
			if($('.accordion .panel-group .panel-default .panel-heading ol')) {
				$('.accordion .panel-group .panel-default .panel-heading ol').parent().parent().parent().siblings('.panel-collapse').find('.panel-body').css({
					'padding': '0 0 0 40px ',
				})

			}
		}
	};

	VerticalCol = {
		init: function () {
			if($('.VerticalCol')) {
				var $specialClassToRemove = $('.VerticalCol');
				$specialClassToRemove.parent('.row').css({
					'margin': 0,
				});
				$specialClassToRemove.each(function () {
					var colDiv = $(this).find('.csc-box');
					$(colDiv).removeClass('col-md-4');
					$(colDiv).removeClass('col-md-8');
				});
			}
		}
	};

	select2 = {
		init: function () {
			$('.select2').select2();
		}
	};

	Cookies = {
		add: function ($cookieName, $val) {
			var cookie = $.cookie($cookieName);
			var items = cookie ? eval("([" + cookie + "])") : [];

			if ($.inArray($val, items) === -1)
				items.push($val);
			$.cookie($cookieName, items.join(','), {expires: 365, path: '/'});
		},
		get: function ($cookieName) {
			var cookie = $.cookie($cookieName);
			var items = cookie ? cookie : '';
			return items.split(',');
		},
		remove: function ($cookieName, $val) {
			var cookie = $.cookie($cookieName);
			var items = cookie ? eval("([" + cookie + "])") : [];

			items = $.grep(items, function ($value) {
				if ($value != $val) {
					$('.add-bookmark[data-project="' + $val + '"]').removeClass('active');
					return true
				}
				return false;
			});
			$.cookie($cookieName, items.join(','), {expires: 365, path: '/'});
		},
		clear: function (cookieName) {
			$.cookie(cookieName, null, {expires: 365, path: '/'});
		}


		// cookieList: function (cookieName) {
		// 	var cookie = $.cookie(cookieName);
		//
		// 	var items = cookie ? eval("([" + cookie + "])") : [];
		//
		// 	return {
		// 		add: function (val) {
		// 			var index = items.indexOf(val);
		//
		// 			// Note: Add only unique values.
		// 			if (index == -1) {
		// 				items.push(val);
		// 				$.cookie(cookieName, items.join(','), {expires: 365, path: '/'});
		// 			}
		// 		},
		// 		remove: function (val) {
		// 			var index = items.indexOf(val);
		//
		// 			if (index != -1) {
		// 				items.splice(index, 1);
		// 				$.cookie(cookieName, items.join(','), {expires: 365, path: '/'});
		// 			}
		// 		},
		// 		indexOf: function (val) {
		// 			return items.indexOf(val);
		// 		},
		// 		clear: function () {
		// 			items = null;
		// 			$.cookie(cookieName, null, {expires: 365, path: '/'});
		// 		},
		// 		items: function () {
		// 			return items;
		// 		},
		// 		length: function () {
		// 			return items.length;
		// 		},
		// 		join: function (separator) {
		// 			return items.join(separator);
		// 		}
		// 	};
		// }
	};

	/**
	 * App: Base application which initializes all other stuff
	 * @type {Object}
	 */
	App = {
		init: function () {
			var cookieMap = Cookies.get('googleMapsAllowed');
			//var cookiePodcast = Cookies.get('podcastsAllowed');
			//App.PodcastOverlay();
			if(cookieMap[0]) {
				var mapPlaceholder = $('.map-placeholder');
				App.MapOSMOverlay();
				mapPlaceholder.hide();
			}
			// if(cookiePodcast[0]) {
			// 	$.removeCookie('podcastsAllowed');
			// }
			$('#map-privacy-check-once').click(function() {
				var mapPlaceholder = $('.map-placeholder');
				mapPlaceholder.hide();
				App.MapsetCookie();
				App.MapOSMOverlay();
			});
			// $('#podcast-privacy-check-once').click(function() {
			// 	var podcastPlaceholder = $('.podcast-overlay-container');
			// 	podcastPlaceholder.hide();
			// 	App.PodcastsetCookie();
			// });

			/* Global Vars */
			glob.pageWrap = $('.wrap-page');
			glob.body = $('body');
			glob.scrollTarget = $('body, html');
			glob.navbar = $('.navbar');
			glob.navbarpostop = glob.navbar.offset()?.top;
			glob.navH = glob.navbar.height();

			if (getUrlParameter('debug') == '1') {
				glob.body.addClass('debug');
				glob.body.append('<div style="background:#00ff00; height: 200px;"></div>');
			}

			// add global device classes to body
			if (glob.ie8) glob.body.addClass('ie8');
			if (glob.ie9) {
				glob.body.addClass('ie9');
			}
			if (glob.ie11) {
				glob.body.addClass('ie11');
			}
			if (glob.touch) {
				glob.body.addClass('touch');
			} else glob.body.addClass('notouch');

			var ps1 = $('#adminOptions form');
			if(ps1.length > 0) {
				$('#adminOptions form').perfectScrollbar();
			}


			if (window.localStorage.getItem('contrast')) {
				glob.body.addClass('contrast');
				$('#contrast').addClass('active');
			}
			switch (window.localStorage.getItem('fontsize')) {
				case 'big':
					glob.body.addClass('big');
					break;
				case 'bigger':
					glob.body.addClass('bigger');
					break;
			}

			/* Init */
			App.handleHomepage();
			if ($('.inner-content .event-list').length > 0) {
				App.handleEventPage();
			}

			App.newsHandle();

			App.handleCarousel();
			// $('.carousel').on('slide.bs.carousel', function () {
			// 	$('.carousel .container-box').animate({
			// 		width: '100%'
			// 	});
			// });
			$('.carousel').on('slid.bs.carousel', function () {
				App.handleCarousel();
			});

			$('#search-button').click(function () {
				var self = $(this),
					searchBox = $('#searchbox');

				if (searchBox.is(':visible')) {
					searchBox.stop(true).fadeOut('slow');
				} else {
					searchBox.stop(true).fadeIn('slow');
				}
			});

			$('#contrast').click(function () {
				var self = $(this);
				if (glob.body.hasClass('contrast')) {
					glob.body.removeClass('contrast');
					self.removeClass('active');
					window.localStorage.removeItem('contrast');
				} else {
					glob.body.addClass('contrast');
					self.addClass('active');
					window.localStorage.setItem('contrast', true);
				}
			});

			$('#fontsize').click(function () {
				var self = $(this);
				if (glob.body.hasClass('big')) {
					glob.body.addClass('bigger');
					glob.body.removeClass('big');
					//self.addClass('bigger');
					//self.removeClass('big');
					window.localStorage.setItem('fontsize', 'bigger');
				} else if (glob.body.hasClass('bigger')) {
					glob.body.removeClass('bigger');
					//self.removeClass('bigger');
					window.localStorage.removeItem('fontsize');
				} else {
					glob.body.addClass('big');
					//self.addClass('big');
					window.localStorage.setItem('fontsize', 'big');
				}
			});

			$('.btn-back').click(function (e) {
				e.preventDefault();
				history.go(-1);
			});

			if ($.cookie('tags')) {
				var Tags = JSON.parse($.cookie('tags'));
			} else {
				var Tags = [];
			}

			$('#news-filter').find('> div').each(function () {
				var id = $(this).data('tag-uid');
				//if($.inArray(id, Tags)>=0) $(this).trigger('click');
			});

			$('#news-filter').find('> div').on('click', function () {
				var id = $(this).data('tag-uid');
				if ($.inArray(id, Tags) >= 0) {
					Tags = jQuery.grep(Tags, function (value) {
						return value != id;
					});
				} else {
					Tags.push(id);
				}
				//$.cookie('tags', JSON.stringify(Tags));
			});

			var nextPrevChoose = $('#NextPrevChoose');
			if (nextPrevChoose.length > 0) {
				var npcId = nextPrevChoose.data('project-id') + '',
					idList = window.localStorage.getItem('voting_id_list').split(','),
					prev = idList[$.inArray(npcId, idList) - 1],
					next = idList[$.inArray(npcId, idList) + 1];

				if (prev == undefined) {
					nextPrevChoose.find('.prevProj').remove();
				}
				if (next == undefined) {
					nextPrevChoose.find('.nextProj').remove();
				}

				if (nextPrevChoose.find('.prevProj').attr('href'))
					nextPrevChoose.find('.prevProj').attr('href', nextPrevChoose.find('.prevProj').attr('href').replace('prevProj', prev));

				if (nextPrevChoose.find('.nextProj').attr('href'))
					nextPrevChoose.find('.nextProj').attr('href', nextPrevChoose.find('.nextProj').attr('href').replace('nextProj', next));

				$('#NextPrevChooseOverlay').css('display', 'none');
			}

			$('a').each(function () {
				var self = $(this);

				if (self.attr('href') != undefined) {
					if (self.attr('href').indexOf('.pdf') > 0 && !self.attr('target')) {
						self.attr('target', '_blank')
					}
				}
			});

			$('a.scroll').on('click', function (e) {
				var href = $(this).attr('href');
				$('html, body').animate({
					scrollTop: $(href).offset().top - 75
				}, 'slow');
				e.preventDefault();
			});
		},

		handleCarousel: function () {
			var sliderWidth = 0;
			if ($('.container-box').hasClass('no-size-change')) return;

			$('.carousel .container-box h3').each(function () {
				var self = $(this);
				if (sliderWidth < self.width()) {
					sliderWidth = self.width();
				}
			});
			$('.carousel .container-box').animate({
				width: sliderWidth + 60
			});
		},

		MapsetCookie: function () {
			var date = new Date();
			date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
			$.cookie('googleMapsAllowed', 1, {expires: date, path: '/'});
		},

		// PodcastsetCookie: function () {
		// 	Cookies.add('podcastsAllowed', 1, { expires: -1 });
		// },

		newsHandle: function () {
			$(document).ready(function () {
				if ($('.news-list-view').length) {
					App.initLazyLoading();
					App.initLazyLoadingNewslist();
					App.initLazyLoadingEventlist();
				}
				if ($('.theme-box').length) App.initLazyLoadingNormal();
			});

			if ($('.news-list-view').length > 0) {
				App.switchView();
				App.filterNews();
			}
		},

		MapOSMOverlay: function() {
			var mapPlaceholder = $('.map-placeholder');
			var osmContainer = $('.OpenStreetMapContainer'),
				osmLng = 0, osmLat = 0, osmAdd = '', osmAddAlt = '';
			if (osmContainer.length > 0) {
				osmLng = osmContainer.data('lng');
				osmLat = osmContainer.data('lat');
				osmAdd = osmContainer.data('address');
				//osmAddAlt = osmContainer.data('address-alt');
				var osmAddress = osmAdd || osmAddAlt;

				if (!osmLng && !osmLat) {
					$.ajax({
						async: false,
						url: 'https://nominatim.openstreetmap.org/search/' + osmAddress + '?format=json&limit=1&polygon_svg=1',
						success: function (d) {
							if (d.length > 0) {
								osmLng = d[0].lon;
								osmLat = d[0].lat;
							}
						}
					});
				}

				if (osmLng && osmLat) OSM.initOSM(osmContainer.attr('id'), osmLng, osmLat);
				else osmContainer.parents('.contentelement-openstreetmaps').remove();
			}
		},

		// PodcastOverlay : function() {
		// 	var podcastPlaceholder = $('.podcast-overlay-container');
		// 	var podcastDiv = $('.podigee-podcast-player');
		// 	var podcastOverlayDiv = '<span class="podcast-overlay-container">\n' +
		// 		'<p>\n' +
		// 		'\Wir möchten Sie darauf hinweisen, dass nach der Aktivierung Daten an den jeweiligen Anbieter übermittelt werden.\n' +
		// 		'<span id="podcast-privacy-check-once" class="link">\n' +
		// 		'\tAudio auf dieser Seite laden\n' +
		// 		'</span>\n' +
		// 		'</p>\n' +
		// 		'\n' +
		// 		'</span>';
		// 	podcastDiv.after(podcastOverlayDiv);
		// },

		initLazyLoading: function () {
			$('.load-more.news').click(function () {

				//$(window).scroll(function() {

				// Lazy load when user reaches the end of the news-list
				//if($(window).scrollTop()+$(window).height() > $('.news-list-view').position().top+$('.news-list-view').outerHeight(true) && lazy_endReached==false && !lazy_loading) {

				// The offset can be the count of currently visible articles
				var offset = $('.news-list-view .article').not('.hidden').length - 1;

				// Set lazy loading true to prevend multiple lazy loading at the same time
				// lazy_loading = true;

				// SEIT 0.2.0 IM TYPOSCRIPT SIEHE TER
				//var constraints = {'categories' : "1,2,3"};

				// Call the function
				// Model = news, jQuery selected news-list-container, offset, limit
				lazyLoadNews('news', $('.news-list-view'), offset, 4);
				//}
				//});
			});
		},

		initLazyLoadingNewslist: function () {
			$('.load-more.newslist').click(function () {
				var self = $(this),
					selfCat = '' + self.data('cat') + '',
					selfCatType = '' + self.data('cat-type') + '',
					selfTag = '' + self.data('tags') + '',
					selfEvent = '' + self.data('is-event') + '',
					items = $('.news-list-view .article'),
					constraints = {},
					offset = items.length - 1;
				// lazy_loading = true;
				var notin = 0 + ',',
					intag = false;
				items.each(function () {
					var selfItem = $(this);
					notin += selfItem.data('uid') + ',';
				});

				if (selfTag) {
					intag += selfTag;
				}

				if ($('#news-filter').length > 0) {
					if ($('#news-filter').children('div').hasClass('btn-primary')) {
						intag = '';
						$('#news-filter').children('div').each(function () {
							var self = $(this);
							if (self.data('tag-uid')) intag += self.data('tag-uid') + ',';
						});
					}
				}

				var i = 0;
				if (selfCat) {
					var selfCats = selfCat.split(',');
					switch (selfCatType) {
						case 'or':
							constraints.categories = {'operator': 'in', 'property': 'categories', 'value': selfCat};
							break;
						case 'and':
							for (i = 0; i < selfCats.length; i++) {
								constraints.categories = {
									'operator': 'equals',
									'property': 'categories',
									'value': selfCats[i]
								};
							}
							break;
						case 'notor':
							constraints.categories = {
								'operator': 'notIn',
								'property': 'categories',
								'value': selfCat
							};
							break;
						case 'notand':
							for (i = 0; i < selfCats.length; i++) {
								constraints.categories = {
									'operator': 'notEquals',
									'property': 'categories',
									'value': selfCats[i]
								};
							}
							break;
						default:
							constraints.categories = {'operator': 'in', 'property': 'categories', 'value': selfCat};
					}
				}

				if (selfEvent) {
					switch (selfEvent) {
						case 1:
							constraints.is_event = {'operator': 'equals', 'property': 'is_event', 'value': 1};
							break;
						case 2:
							constraints.is_event = {'operator': 'equals', 'property': 'is_event', 'value': 0};
							break;
						default:
							constraints.is_event = {'operator': 'in', 'property': 'is_event', 'value': [0, 1]};
					}
				}

				constraints.uid = {'operator': 'notIn', 'property': 'uid', 'value': notin};
				//constraints.is_event = {'operator': 'equals', 'property': 'is_event', 'value': 1};

				if (intag) {
					intag = intag.replace('false', '');
					constraints.tags = {'operator': 'in', 'property': 'tags', 'value': intag};
				}

				lazyLoadNews('news', $('.news-list-view .news-inner-list'), 0, 4, constraints, 4);
			});
		},

		// TODO: Funktionen Zusammenführen -> Kann aufgrund von Data-Parameter in einer Funktion zusammen gefasst werden.
		initLazyLoadingEventlist: function () {
			$('.load-more.eventlist').click(function () {
				var self = $(this),
					selfCat = '' + self.data('cat') + '',
					selfCatType = '' + self.data('cat-type') + '',
					selfLazyPage = '' + self.data('lazy-page') + '',
					selfLazyDetailPage = '' + self.data('lazy-detail') + '',
					selfTag = '' + self.data('tags') + '',
					selfSorting = '' + self.data('sorting') + '',
					selfPID = '' + self.data('pid') + '',
					selfSortingDirection = '' + self.data('order-direction') + '',
					items = $('.news-list-view .article').not('.hidden'),
					constraints = {},
					offset = items.length - 1,
					anerkannteVeranstaltungButton = $('#anerkannt');
				// lazy_loading = true;
				var notin = '',
					intag = false;


				items.each(function () {
					var selfItem = $(this);
					notin += selfItem.data('uid') + ',';
				});

				//console.log(selfPID);

				if (selfTag) {
					intag = selfTag;
				}

				if ($('#news-filter').length > 0) {
					if ($('#news-filter').children('div').hasClass('btn-primary')) {
						intag = '';
						$('#news-filter').children('div.btn-primary').each(function () {
							var self = $(this);
							if (self.data('tag-uid')) intag += self.data('tag-uid') + ',';
						});
					}
				}

				if ($('.form-events-list').length > 0) {
					var zip = $('#form-event-zip'),
						zipValue = zip.val(),
						area = $('#form-event-area'),
						areaValue = area.val();
				}

				if (selfSorting) {
					constraints.sorting = {
						'operator': selfSortingDirection,
						'property': 'sorting',
						'value': selfSorting
					};
				}

				var i = 0;
				if (selfCat) {
					var selfCats = selfCat.split(',');
					switch (selfCatType) {
						case 'or':
							constraints.categories = {'operator': 'in', 'property': 'categories', 'value': selfCat};
							break;
						case 'and':
							for (i = 0; i < selfCats.length; i++) {
								constraints.categories = {
									'operator': 'equals',
									'property': 'categories',
									'value': selfCats[i]
								};
							}
							break;
						case 'notor':
							constraints.categories = {
								'operator': 'notIn',
								'property': 'categories',
								'value': selfCat
							};
							break;
						case 'notand':
							for (i = 0; i < selfCats.length; i++) {
								constraints.categories = {
									'operator': 'notEquals',
									'property': 'categories',
									'value': selfCats[i]
								};
							}
							break;
						default:
							constraints.categories = {'operator': 'in', 'property': 'categories', 'value': selfCat};
					}
				}

				constraints.uid = {'operator': 'notIn', 'property': 'uid', 'value': notin};
				constraints.is_event = {'operator': 'equals', 'property': 'is_event', 'value': 1};

				if (intag) {
					intag = intag.replace('false', '');
					constraints.tags = {'operator': 'in', 'property': 'tags', 'value': intag};
				}

				if (selfPID > 0) {
					constraints.pid = {'operator': 'in', 'property': 'pid', 'value': selfPID};
				}

				if (glob.isFortbildung && !anerkannteVeranstaltungButton.hasClass('btn-primary')) {
					constraints.notags = {
						'operator': 'notIn',
						'property': 'notags',
						'value': '51'
					};
				}

				// TODO: Check Offset if "notin" set offset = 0 else offset items.length
				lazyLoadNews('news', $('.news-list-view .news-inner-list'), 0, 3, constraints, 3, false, selfLazyPage, selfLazyDetailPage, [zipValue, areaValue]);
			});
		},

		initLazyLoadingNormal: function () {
			$('.load-more.default-element.news').click(function () {
				var self = $(this),
					selfCat = '' + self.data('cat') + '',
					selfTop = self.data('top-news'),
					boxCount = 0,
					offset = $('.theme-box.news-box').length - 1,
					quant = 9,
					constraints = {},
					notin = '';

				if (self.data('reload-items')) {
					quant = self.data('reload-items');
				}

				$('.inner-content').children('.content-div').children('.csc-default').each(function () {
					var box = $(this);

					if (box.hasClass('col-md-4')) {
						boxCount += 1;
					} else if (box.hasClass('col-md-8')) {
						boxCount += 2;
					}
				});

				if (boxCount % 3 != 0) {
					quant = quant + (3 - boxCount % 3);
				}

				$('.theme-box.news-box').each(function () {
					var self = $(this);
					notin += self.data('uid') + ',';
				});
				$('.article.news-item').each(function () {
					var self = $(this);
					notin += self.data('uid') + ',';
				});
				constraints.uid = {'operator': 'notIn', 'property': 'uid', 'value': notin};

				if (selfCat) {
					constraints.categories = {'operator': 'in', 'property': 'categories', 'value': selfCat};
				}
				if (selfTop == 1) {
					constraints.istopnews = {'operator': 'equals', 'property': 'istopnews', 'value': selfTop};
				}

				// lazy_loading = true;
				lazyLoadNews('news', $('.inner-content > .content-div'), offset, quant, constraints, 3);
			});
		},

		setTagFilter: function () {
			if (window.localStorage.getItem("newsFilter") !== null) {
				var newsFilter = JSON.parse(window.localStorage.getItem("newsFilter"));

				for (var i = 0; i < newsFilter.length; i++) {
					$('div[data-tag-uid="' + newsFilter[i] + '"]').addClass('btn-primary');
				}
			}
		},

		applyTagFilter: function () {
			var actFilter = [],
				filter = $('#news-filter div, #anerkannt');

			filter.each(function () {
				var self = $(this);

				if (self.hasClass('btn-primary')) {
					actFilter.push(self.data('tag-uid'));
				}
			});

			window.localStorage.setItem('newsFilter', JSON.stringify(actFilter));
			App.setNewsFilter();
		},

		filterNews: function () {
			if (glob.isNotNews) return;
			var filter = $('#news-filter div, #anerkannt'),
				eventFilter = $('.event-filter'),
				extraFilter = $('#extra-filter-button'),
				extraResetButton = $('#extra-filters .reset-button');

			if (eventFilter.length > 0) {
				var eventFilterButton = eventFilter.find('input[type="checkbox"]'),
					eventList = $('.eventlist');

				// Intern/Extern Buttons
				eventFilterButton.click(function (e) {
					var self = $(this),
						selfFilterContainer = self.parents('.event-filter'),
						pidIntern = $('#intern').data('value'),
						pidExtern = $('#extern').data('value'),
						selfPID = '' + self.data('value') + '',
						items = $('.news-list-view .article[data-starting="' + selfPID + '"]'),
						constraints = {},
						addContraints = {},
						offset = items.length - 1,
						newItems = 3,
						rowItems = 3;

					if (items.length < 9) {
						newItems = 9;
					}

					if (items.length % rowItems > 0) {
						newItems = newItems - (items.length % rowItems);
					}

					var buttonValue = false;
					if (self.is(':checked')) {
						buttonValue = true;
					}

					var buttonStates = App.getFilterButtonStates();

					if ($(this).attr('id') == 'intern') {
						buttonStates.intern = buttonValue;
					}

					if ($(this).attr('id') == 'extern') {
						buttonStates.extern = buttonValue;
					}
					if (selfFilterContainer.hasClass('veranstaltungen')) {
						App.setFilterButtonStates(buttonStates, 'V');
					} else if (selfFilterContainer.hasClass('fortbildungen')) {
						App.setFilterButtonStates(buttonStates, 'F');
					}

					// if intern XOR extern
					if ((buttonStates.intern || buttonStates.extern) &&
						!(buttonStates.intern && buttonStates.extern)) {

						var pid = pidIntern;
						if (buttonStates.extern) {
							pid = pidExtern;
						}

						eventList.data('pid', pid);

						$('.article').each(function () {
							var article = $(this);
							if (article.data('starting') == pid) {
								article.show().removeClass('hidden');
							} else {
								article.hide().addClass('hidden');
							}
						});
						if (selfPID > 0) {
							addContraints.pid = {
								'operator': 'in',
								'property': 'pid',
								'value': selfPID,
								'override': 'add'
							};
						}
						// lazyLoadNews('news', $('.news-list-view .news-inner-list'), offset, 3, constraints, 3, false);
						// lazyLoadNews('news', $('.news-list-view .news-inner-list'), offset, newItems, constraints, 3, false);
					} else {
						$('.article').each(function () {
							var article = $(this);
							article.show().removeClass('hidden');
						});

						eventList.data('pid', false);
					}

					App.applyTagFilter();
					App.fillNews(3, addContraints);
				});
			}

			if (window.localStorage.getItem("newsFilter") !== null) {
				var newsFilter = JSON.parse(window.localStorage.getItem("newsFilter"));

				for (var i = 0; i < newsFilter.length; i++) {
					$('div[data-tag-uid="' + newsFilter[i] + '"]').addClass('btn-primary');
				}
			}

			// Tag-Buttons
			filter.click(function () {
				var filterEl = $(this);

				if (filterEl.hasClass('btn-primary')) {
					filterEl.removeClass('btn-primary');
				} else {
					filterEl.addClass('btn-primary');
				}

				App.applyTagFilter();
			});

			// Extra-Filter (Umkreissuche, etc)
			extraFilter.click(function () {
				var self = $(this);
				var targetId = '#extra-filters';

				if (self.hasClass('btn-primary')) {
					self.removeClass('btn-primary');
					$(targetId).fadeOut();
				} else {
					extraFilter.removeClass('btn-primary');
					self.addClass('btn-primary');
					$(targetId).fadeIn();
				}
			});

			extraResetButton.click(function (e) {
				e.preventDefault();

				$('#form-event-zip').val('');
				$('#form-event-area').val('');
				$('#form-event-subject-areas').val('');
				$('#form-event-credits').val('');

				$('#form_event_area_chosen .chosen-single span').text('50 km');
				$('#form_event_subject_areas_chosen .chosen-single span').text('Keine Einschränkung');
				$('#form_event_credits_chosen .chosen-single span').text('Keine Einschränkung');

				$('#filter-form-felist').submit();
			});

			// automatisches auswählen von "Anerkannte Veranstaltungen deaktivieren
			// $('#anerkannt').addClass('btn-primary');

			App.setInternExtern();
			App.setExtraFilters();
			if (!$('#isStellenmarkt').data('value')) {
				App.setNewsFilter();
			}
		},

		getFilterButtonStates: function () {
			var eventFilter = $('.event-filter'), buttonStates = {};

			if (eventFilter.hasClass('veranstaltungen')) {
				buttonStates = window.localStorage.getItem('filterButtonStateV');
				if (buttonStates === null) {
					buttonStates = {
						intern: true,
						extern: true
					}
				} else {
					buttonStates = JSON.parse(buttonStates);
				}
			}

			if (eventFilter.hasClass('fortbildungen')) {
				buttonStates = window.localStorage.getItem('filterButtonStatesF');
				if (buttonStates === null) {
					buttonStates = {
						intern: true,
						extern: false
					}
				} else {
					buttonStates = JSON.parse(buttonStates);
				}
			}

			return buttonStates;
		},

		setFilterButtonStates: function (buttonStates, type) {
			window.localStorage.setItem('filterButtonStates' + type, JSON.stringify(buttonStates));
		},

		setInternExtern: function () {
			var buttonStates = App.getFilterButtonStates();
			var intern = $('#intern');
			var extern = $('#extern');

			if (buttonStates.intern == true) {
				if (!intern.is(':checked')) {
					intern.trigger('click');
				}
			}

			if (buttonStates.extern == true) {
				if (!extern.is(':checked')) {
					extern.trigger('click');
				}
			}
		},

		setExtraFilters: function () {
			var area = $('#form-event-zip').val();
			var subjectAreas = $('#form-event-subject-areas').val();
			var credits = $('#form-event-credits').val();

			if (area != '' || ((subjectAreas != '0' && subjectAreas != undefined) && subjectAreas != undefined) || (credits != '0' && credits != undefined)) {
				$('#extra-filter-button').addClass('btn-primary');
				$('#extra-filters').show();
			}
		},

		setNewsFilter: function () {
			if (glob.isNotNews) return;
			var newsFilter = JSON.parse(window.localStorage.getItem("newsFilter")),
				cols = 4,
				addContraints = {};
			if (newsFilter == null) {
				newsFilter = []
			}
			glob.articles = $('.news-list-view .article').not('.hidden').length;

			if (glob.isFortbildung || glob.isVeranstaltung)
				cols = 3;

			if (newsFilter.length == 0) {
				$('.news-list-view .article').each(function () {
					var self = $(this);
					if (self.addClass('isInFilter')) {
						self.removeClass('hidden');
					}

					if (
						$.inArray('51', self.data('tags').toString().split(',')) >= 0 &&
						glob.isFortbildung
					) {
						self.addClass('hidden');
						addContraints = {
							'notags': {'operator': 'notIn', 'property': 'notags', 'value': '51', 'override': 'append'}
						};
					}
				});
				App.fillNews(cols, addContraints);
				return;
			}

			// console.log(newsFilter);

			$('.news-list-view .article').each(function () {
				var selfNews = $(this),
					selfNewsTags = selfNews.data('tags').toString();
				var tagArray = (selfNewsTags.toString()).split(',');
				var match = false;
				for (var i = 0; i < newsFilter.length; i++) {
					if ($.inArray(newsFilter[i].toString(), tagArray) > -1) {
						match = true;
					}
				}

				if (match) {
					selfNews.addClass('isInFilter').removeClass('hidden');
				} else {
					if (glob.isFortbildung) {
						if (newsFilter[0] == 51) {
							selfNews.removeClass('isInFilter').removeClass('hidden');
						} else selfNews.removeClass('isInFilter').addClass('hidden');
					} else {
						if (glob.isVeranstaltung) {
							if (newsFilter[0] == 52) {
								var selfTags = ($.isNumeric(selfNewsTags)) ? [selfNewsTags] : selfNewsTags.split(','),
									isInArray = false;
								for (var t = 0; t < selfTags.length; t++) {
									if ($.inArray(selfTags[t].toString(), ["23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "52"]) >= 0)
										isInArray = true;
								}
								if (isInArray) selfNews.addClass('isInFilter').removeClass('hidden');
								else selfNews.removeClass('isInFilter').addClass('hidden');
							} else selfNews.removeClass('isInFilter').addClass('hidden');
						} else selfNews.removeClass('isInFilter').addClass('hidden');
					}
				}
			});


			App.fillNews(cols);
		},

		// App.sortNews(sorting,append);
		sortNews: function ($sortings, $append) {
			if (glob.isFortbildung || glob.isVeranstaltung) {
				$sortings.sort(function (a, b) {
					var contentA = parseInt($(a).attr('data-datetime'));
					var contentB = parseInt($(b).attr('data-datetime'));
					return (contentA < contentB) ? -1 : (contentA > contentB) ? 1 : 0;
				}).prependTo($append);
			}
		},

		fillNews: function (cols, addContraints) {
			if (glob.isNotNews) return;
			cols = cols || 4;
			addContraints = addContraints || {};
			var newsList = $('.news-list-view .news-inner-list'),
				items = $('.news-list-view .article'),
				viewedItems = $('.news-list-view .article').not('.hidden'),
				hiddenItems = $('.news-list-view .article.hidden').length,
				newsFilter = $('#news-filter'),
				newsFilterChoosen = newsFilter.children('.btn-primary'),
				loadMoreButton = $('.load-more'),
				selfPID = '' + loadMoreButton.data('pid') + '',
				isEvent = false,

				notin = '',
				notinUid = '',
				intag = false,
				contraints = {},
				newItems = cols,
				rowItems = cols,
				minItems = (cols == 4) ? 12 : 9;

			if (viewedItems.length < minItems) {
				newItems = minItems;
			}

			if (viewedItems.length % rowItems > 0) {
				newItems = newItems - (viewedItems.length % rowItems);
			}

			if ($('.news-elements').length) {
				isEvent = false;
			} else if ($('.event-elements').length) {
				isEvent = true;
			}

			if (newsFilter.length > 0) {
				intag = '';
				if (newsFilterChoosen.length > 0) {
					newsFilterChoosen.each(function () {
						var self = $(this);
						if (self.data('tag-uid')) intag += self.data('tag-uid') + ',';
					});
				} else if (loadMoreButton.length > 0) {
					intag = loadMoreButton.data('tags').toString();
				}
			}

			if ($('.form-events-list').length > 0) {
				var zip = $('#form-event-zip'),
					zipValue = zip.val(),
					area = $('#form-event-area'),
					areaValue = area.val();
			}

			items.each(function () {
				var self = $(this);
				notin += self.data('uid') + ',';
			});

			if (hiddenItems > 0) {
				if (isEvent) {
					cols = 3;
					contraints = {
						'categories': {'operator': 'notIn', 'property': 'uid', 'value': notin},
						'is_event': {'operator': 'in', 'property': 'is_event', 'value': 1},
						'event_sorting': {'operator': 'asc', 'property': 'sorting', 'value': 'datetime'}
					};
				} else {
					contraints = {
						'categories': {'operator': 'notIn', 'property': 'uid', 'value': notin},
						'is_event': {'operator': 'notIn', 'property': 'is_event', 'value': 1}
					};
				}

				if (intag) {
					intag = intag.replace('false', '');

					if (isEvent) {
						contraints = {
							'categories': {'operator': 'notIn', 'property': 'uid', 'value': notin},
							'is_event': {'operator': 'in', 'property': 'is_event', 'value': 1},
							'tags': {'operator': 'in', 'property': 'tags', 'value': intag},
							'sorting': {'operator': 'asc', 'property': 'sorting', 'value': 'datetime'}
						};
					} else {
						contraints = {
							'categories': {'operator': 'notIn', 'property': 'uid', 'value': notin},
							'is_event': {'operator': 'in', 'property': 'is_event', 'value': 0},
							'tags': {'operator': 'in', 'property': 'tags', 'value': intag}
						};
					}
				}

				if (selfPID > 0) {
					contraints.pid = {'operator': 'in', 'property': 'pid', 'value': selfPID};
				}

				$.each(addContraints, function (consTyp, childobj) {
					if (childobj.override === 'add') {
						delete childobj.override;
						if ((contraints[consTyp].operator === 'in' && childobj.operator === 'in') ||
							(contraints[consTyp].operator === 'notIn' && childobj.operator === 'notIn')) {
							contraints[consTyp].value = contraints[consTyp].value + ',' + childobj.value
						} else if (contraints[consTyp].operator === 'in' && childobj.operator === 'notIn') {
							var constArray = contraints[consTyp].value.split(','),
								addConstArr = childobj.value.split(','),
								newString = [];
							for (var i = 0; i < constArray.length; i++) {
								if ($.inArray(constArray[i], addConstArr) === -1) {
									newString.push(constArray[i]);
								}
							}
							newString = newString.join(',');
							contraints[consTyp].value = newString;
						}
					} else if (childobj.override === 'override') {
						delete childobj.override;
						contraints[consTyp].operator = childobj.operator;
						contraints[consTyp].property = childobj.property;
						contraints[consTyp].value = childobj.value;
					} else if (childobj.override === 'append') {
						delete childobj.override;
						$.extend(contraints, addContraints);
					}
				});

				lazyLoadNews('news', $('.news-list-view .news-inner-list'), 0, newItems, contraints, cols, isEvent, false, false, [zipValue, areaValue]);
				// lazyLoadNews('news', $('.news-list-view .news-inner-list'), items.length, newItems, contraints, cols, isEvent, false, false, [zipValue, areaValue]);
			} else {
				if (intag && intag.indexOf(51) >= 0) {
					hiddenItems = hiddenItems || 3;

					if (intag) {
						intag = intag.replace('false', '');

						if (isEvent) {
							contraints = {
								'categories': {'operator': 'notIn', 'property': 'uid', 'value': notin},
								'is_event': {'operator': 'in', 'property': 'is_event', 'value': 1},
								'tags': {'operator': 'in', 'property': 'tags', 'value': intag},
								'sorting': {'operator': 'asc', 'property': 'sorting', 'value': 'datetime'}
							};
						} else {
							contraints = {
								'categories': {'operator': 'notIn', 'property': 'uid', 'value': notin},
								'is_event': {'operator': 'in', 'property': 'is_event', 'value': 0},
								'tags': {'operator': 'in', 'property': 'tags', 'value': intag}
							};
						}
					}

					lazyLoadNews('news', $('.news-list-view .news-inner-list'), items.length, newItems, contraints, cols, isEvent, false, false, [zipValue, areaValue]);
				}
			}

			App.sortNews(items, newsList);

			// window.localStorage.removeItem('newsFilter');
		},

		switchView: function () {
			var layoutSwitcher = $('.layout-switcher'),
				switcher = layoutSwitcher.find('.switcher'),
				switcherElement = switcher.children('i');

			switcherElement.click(function () {
				var self = $(this);

				if (self.data('switch') == 'list') {
					$('.news .news-list-view').addClass('list').removeClass('block').find('.theme-box').addClass('full-length').off();
				} else {
					$('.news .news-list-view').addClass('block').removeClass('list').find('.theme-box').removeClass('full-length');
					App.contentElementAnimations();
				}
				switcherElement.each(function () {
					var el = $(this);
					if (el.data('switch') == self.data('switch')) {
						el.addClass('active');
					} else {
						el.removeClass('active');
					}
				});
			});
		},

		handleEventPage: function () {
			var innerContent = $('.inner-content'),
				eventList = innerContent.find('.event-list'),
				eventBoxes = eventList.children('div').not('.load-more'),
				types = [], categorys = [],

				typeFilter = $('<div class="event-types"></div>'),
				categoryFilter = $('<div class="event-categorys"></div>'),
				switcher = $('<div class="switcher"><i class="fa fa-th-large active" aria-hidden="true"></i><i class="fa fa-bars" aria-hidden="true"></i></div>');

			//typeFilter.append(switcher);

			eventBoxes.each(function () {
				var self = $(this);

				if (self.data('type') && $.inArray(self.data('type'), types) < 0) {
					types.push(self.data('type'));
					typeFilter.append('<span data-type="' + self.data("type") + '">' + self.data("type") + '</span>');
				}
				if (self.data('category') && $.inArray(self.data('category'), categorys) < 0) {
					categorys.push(self.data('category'));
					categoryFilter.append('<span data-category="' + self.data("category") + '">' + self.data("category") + '</span>');
				}
			});

			innerContent.prepend(typeFilter).prepend(categoryFilter);

			var catLinks = $('.inner-content .event-categorys span'),
				typeLinks = $('.inner-content .event-types span');

			catLinks.click(function () {
				var self = $(this);

				eventBoxes.each(function () {
					var eb = $(this);
					if (eb.data('category') == self.data('category')) {
						eb.fadeIn('slow');
					} else {
						eb.fadeOut('slow');
					}
				});
			});

			typeLinks.click(function () {
				var self = $(this);

				eventBoxes.each(function () {
					var eb = $(this);
					if (eb.data('type') == self.data('type')) {
						eb.fadeIn('slow');
					} else {
						eb.fadeOut('slow');
					}
				});
			});
		},

		contentElementAnimations: function () {
			var themeBox = $('.theme-box'),
				eventBox = $('.event-box'),
				selectBox = $('.select-box');

			themeBox.each(function () {
				var selfTB = $(this),
					selfBackground = selfTB.find('.bg-image'),
					selfImage = selfTB.find('.image'),
					selfText = selfTB.find('.inner-text');

				if (selfTB.hasClass('with-image') && !selfTB.hasClass('full-length') && !selfTB.hasClass('no-image')) {

					selfTB.hover(function () {
						var boxValue = 285;
						if ($('body').hasClass('big')) boxValue = 300;
						if ($('body').hasClass('bigger')) boxValue = 320;
						if (glob.winW > 992) {
							selfText.stop(true).animate({
								marginTop: boxValue * -1
							}, 'slow');
							selfImage.stop(true).animate({
								height: boxValue
							}, 'slow');
						}
					}, function () {
						var boxValue = 285;
						if ($('body').hasClass('big')) boxValue = 300;
						if ($('body').hasClass('bigger')) boxValue = 320;
						selfText.stop(true).animate({
							marginTop: 0
						}, 'slow');
						selfImage.stop(true).animate({
							height: 195
						}, 'slow');
					});
				}
			});

			eventBox.each(function () {
				var selfEB = $(this),
					selfBackground = selfEB.find('.bg-image'),
					selfImage = selfEB.find('.image');

				if (selfEB.hasClass('with-image') && !selfEB.hasClass('full-length')) {
					selfImage.css('background-size', '100%');
					selfEB.hover(function () {
						selfImage.stop(true).animate({
							backgroundSize: '120%'
						});
					}, function () {
						selfImage.stop(true).animate({
							backgroundSize: '100%'
						});
					});
				} else {
					selfEB.hover(function () {
						if (glob.winW > 992) {
							selfBackground.stop(true).animate({
								top: 0
							});
						}
					}, function () {
						selfBackground.stop(true).animate({
							top: 285
						});
					});
				}
			});

			var selectionBoxElement = $('.selection-box-element');
			selectionBoxElement.each(function () {
				var self = $(this),
					selectionBoxChild = self.find('.select-box');

				selectionBoxChild.each(function ($index, $element) {
					var self = $(this);
					if(window.matchMedia("(max-width: 767px)").matches){
						if (!self.parent('div').next().hasClass('sb-preview'))
							self.parent('div').after('<div class="col-xs-12 sb-preview"></div>');
					}
					else {
						if (($index + 1) % 3 == 0 || ($index + 1) == selectionBoxChild.length) {
							if (!self.parent('div').next().hasClass('sb-preview'))
								self.parent('div').after('<div class="col-xs-12 sb-preview"></div>');
						}
					}

				});
			});

			selectBox.not('.no-slide').click(function () {
				var self = $(this),
					sb = self.parent('div'),
					sbInfo = self.find('.additional_infos').clone(),
					sbNext = sb.next();
				if (!sbNext.hasClass('sb-preview')) {
					sbNext = sb.next().next();
				}
				if (!sbNext.hasClass('sb-preview')) {
					sbNext = sb.next().next().next();
				}

				sbNext.stop(true).slideUp('slow', function () {
					sbNext.html(sbInfo).stop(true).slideDown('slow');
					BookmarkHandling.addBookmark();
					sbNext.find('.close').click(function () {
						sbNext.stop(true).slideUp('slow');
					});
				});
			});
		},

		handleHomepage: function () {
			var homepage = $('#homepage'),
				jumpTo = $('.jump_to_next_element'),
				contentWrapper = $('#content'),
				contentWrapperPadding = contentWrapper.css('padding-top');

			if (homepage.length > 0) {
				App.changePaddingTop();
				glob.navbarpostop = glob.navbar.offset().top;
				$(window)
					.resize(function () {
						App.changePaddingTop();
					})
					.scroll(function () {
						//$('#header').css('top', ($(document).scrollTop()));
						if (glob.navbarpostop <= $(document).scrollTop()) {
							glob.navbar.css('position', 'fixed');
							contentWrapper.css('padding-top', parseInt(contentWrapperPadding) + parseInt(glob.navbar.height()));
						} else {
							glob.navbar.css('position', 'relative');
							contentWrapper.css('padding-top', parseInt(contentWrapperPadding));
						}
						//if ($(document).scrollTop() >= glob.navbar.offset().top) {
						//	glob.navbar.css('position','fixed');
						//} else {
						//	glob.navbar.css('position','relative');
						//}
					});
			}

			jumpTo.click(function () {
				var self = $(this),
					selfJump = self.data('element');
				glob.scrollTo($(selfJump), 75);
				//glob.scrollTo($(selfJump), 50, 'easeOutBounce');
			});

			App.contentElementAnimations();

			$('.load-more').not('.news,.newslist,.eventlist,.tda').click(function () {
				var self = $(this),
					pasteContainer = (self.hasClass('news')) ? $('.inner-content > .content-div .news-list') : $('.inner-content > .content-div'),

					contentInsert = (self.hasClass('news')) ?
						['<div class="news-item" style="display: none;">						<div class="news-date">7. Juli 2016</div>					<div class="news-content">						<h2>Architekturpreis Wein wird auf der Gartenschau in Landau präsentiert</h2>					<p>Die Ausstellung des Architekturpreises Wein macht auf der Landesgartenschau in Landau bis zum 19. Juli						2015 im Gebäude 110 Station. Beim bundesweit ausgelobten Preis waren immerhin neun rheinland-pfäl-						zische Betriebe erfolgreich. Darüber hinaus sind in der Wanderausstellung alle 14 prämierten Bauten						vertreten. Kühler Wein im schattigen Garten, das, so die Deutschen Weinkönigin Janina Huhn anlässlich						der Eröffnung bei sommerlich heißen Temperaturen, passt ebenso gut zusammen, wie anspruchsvolles						Bauen und vom Ministerium für Umwelt, Landwirtschaft, Ernährung, Weinbau und Forsten. Die Runde dis-						kutierte die Zukunft von Tourismus und Weinwirtschaft in Rheinland-Pfalz.						</p>						<img src="/fileadmin/_processed_/f/3/csm_1._preis_wb_neugestaltung_loreley_plateau_plandrei_landschaftsarchitektur_gmbh_knabe_baukonsult_pohl_architekten_und_wilke_stadtplaner_visualisierung-rendertaxi-aachen_221b6ca744.jpg" width="1280" height="1024" alt="">							<div class="caption">Ut illuptatium lamsi coreped iorisin consentus veniet aut quiaectus.</div>						</div>						</div>',
							'<div class="news-item" style="display: none;">						<div class="news-date">29. Oktober 2016</div>						<div class="news-content">							<h2>Architekturpreis Wein im Kurfürstlichen Palais in Trier</h2>						<p>Pis ut faccatium repudit laboriaestet ut que ipsam sit, quidunt eos non nihit anihillaut ventest, sus						dolore paruptate voloresequia dellantur maxim que doluptatium, et ad maio occulluptae. Ullut re odiae						abori sit poreped quatur audi ommos doluptat videlibeat quaestem ad enienti buscia ped mintur se						voluptam si iunt quam quatin nos alitatia quatum, voles eum nonsequi volenim ex ese nest ma atus simi,						non comnis doluptat ut mi, cuscius, officil eum atis auditibus moluptur, quianda pro maximustium estemo						TERMIN voloreped moditist ex eicim aut facerrumquas am, odis et facepel int fuga. Ectorectur Rum, quam						que reces velique di reium reperat estius quae pliquis auta voluptat liquam, opta. </p>						</div>						</div>',
							'<div class="news-item" style="display: none;">						<div class="news-date">3. November 2016</div>						<div class="news-content">							<h2>Lorem ipsum porem</h2>						<p>Berum dolore elendis et ea cora nimaxim aximpos sentur assimolo molorum et doluptatet exceste mi,							soluptis qui quas aut atemqui audam, quas am sit lam quia comnis quid molorib usaped qui dolum ni							dolupis truptati dolorum alit parchilis atibus doluptatem et aut ea quasinit et ventin nonest et que venist							ut latendis et ditam aute nos ipsam exceperume mo que se cusciam qui idundel luptasinum atus maxim							denditatem adipsantiisi blab is dicilitisqui quaest, sit exceat harchil itiuscil modios saepudae pro beatus,							vellorpore comnis excea volut officiis solupti blabo. Ut et dolupta spelect ionserum ullat. Is etur amus,							officipis dolorio conserum que que latur saerita volorehendam ressimo lupiti						</p>						</div>						</div>',
							'<div class="news-item" style="display: none;">						<div class="news-date">3. November 2016</div>						<div class="news-content">							<h2>Lorem ipsum porem</h2>						<p>Berum dolore elendis et ea cora nimaxim aximpos sentur assimolo molorum et doluptatet exceste mi,							soluptis qui quas aut atemqui audam, quas am sit lam quia comnis quid molorib usaped qui dolum ni							dolupis truptati dolorum alit parchilis atibus doluptatem et aut ea quasinit et ventin nonest et que venist							ut latendis et ditam aute nos ipsam exceperume mo que se cusciam qui idundel luptasinum atus maxim							denditatem adipsantiisi blab is dicilitisqui quaest, sit exceat harchil itiuscil modios saepudae pro beatus,							vellorpore comnis excea volut officiis solupti blabo. Ut et dolupta spelect ionserum ullat. Is etur amus,							officipis dolorio conserum que que latur saerita volorehendam ressimo lupiti						</p>						</div>						</div>',
							'<div class="news-item" style="display: none;">						<div class="news-date">10. Dezember 2016</div>						<div class="news-content">							<h2>Lorem ipsum porem</h2>						<p>Pudae. Itaerchit porem quianis et aliqui quis as explique quiasi conet quia quid eum accum dis aut offic							tem sim etus aut acercil ligent officidem quasimpos porist la dest, simusam, qui sam fuga. Hic tectati is							re dunt plibus vel mintur abor aliae venis ipient et eum rem audis estioritiis eum labo. On explam, cor re							sus si cum, volo essim faccus nobit lis ex et etus, comnimi, cuptatur, untur aut aliquissit aliquia ssunto							doluten distium net eost et volore officima que si a ex estotae. Ebit voluptibus audaerum adicatur, unt							rest que pa in nonsed qui velectust, occaerunt laborib usdandiam et ad que landunt mostotat volor sit es							alis id et, sinullab is comnihi liquaep tationes magnimo lumque comnimil eic tempore nobitas di unt, que							nonecta							</p>							<img src="/fileadmin/_processed_/f/6/csm_2fd6b122c8cfe2658b56539a36d738a2_5b43f1c6a1.jpg" width="1280" height="1024" alt="">							<div class="caption">Ut illuptatium lamsi coreped iorisin consentus veniet aut quiaectus.</div>						</div>						</div>']
						:
						['<div style="display: none;"><div class="csc-default col-xs-12 col-md-8">	<div class="theme-box with-image double">		<div class="image"		     style="background-image: url(/fileadmin/images/bilder/haus_alpen.jpg);"></div>		<div class="overlay"></div>		<div class="inner-text">			<h3>Baukultur</h3>			<h2>Rasi dolecea diorem nobis gut voluptatia quas a quirae es invtoris con</h2>			<p class="text">				Fea diorem. Occaectas unt aliciam quam nobis voluptatia vel maiorum quasa qui quam nobis voluptatia				frgvel maiorum vent et qua. Apelendios autem voluptatur aliquatem que dem faccaborepre saperor umquam			volupt.</p>		</div>	</div></div><div class="csc-default col-xs-12 col-md-4">	<div class="theme-box colored">		<h3>Symposium</h3>		<h2>Acocum cideli lorem uga uritati nobis busadia</h2>		<p class="text">Fea diorem. Occaectas unt aliciam quam nobis voluptatia vel maiorum quasa qui quam nobis			voluptatia frgvel maiorum vent et qua.</p>	</div></div></div>',
							'<div style="display: none;"><div class="csc-default col-xs-12 col-md-4">	<div class="theme-box">		<h3>Symposium</h3>		<h2>Acocum cideli lorem uga uritati nobis busadia</h2>		<p class="text">Fea diorem. Occaectas unt aliciam quam nobis voluptatia vel maiorum quasa qui quam nobis			voluptatia frgvel maiorum vent et qua. Apelendios autem voluptatur aliquatem que dem faccaborepre saperor			umquam volupt.</p>	</div></div><div class="csc-default col-xs-12 col-md-8">	<div class="theme-box double">		<h3>News</h3>		<h2>Rasi dolecea diorem nobis gut voluptatia quas a quirae es invtoris con</h2>		<p class="text">Sum ra consequibus, occaepudant volore essusant. Facerio nsequati omnihicia simus, si beritas			sitate aut fuga. Fugit, corro ma quati di ut a ped qui to dolorporem volorae ssequi re volupta quia nobit			volupta tinus. Ut et velluptatus andendu sdandae que nonsequi ut volupta tecaest, quiatus alignate nonecab.			Icidunt, ium volupti amendit atiorestio modis ratis simendigenda culparum quoditiberum alignia speliquunt.			Nimpe nonse porio voluptatias am sit doluptatus, seditaquatur remporum ex explicatem suntibu sandisit est			lab ipidus autemquiaes del magnam, nist officabore eos</p>	</div></div></div>',
							'<div style="display: none;"><div class="csc-default col-xs-12 col-md-4">	<div class="event-box">		<div class="bg-image"		     style="background-image: url(/fileadmin/images/bilder/haus_alpen.jpg);"></div>		<div class="overlay"></div>		<div class="inner-text">			<h3>Event</h3>			<p class="date">				<span class="day">25</span>				<span class="month">November</span>				<span class="year">2017</span>			</p>			<p class="text">67. Kongress für das internationale Badewesen 2017 aut dolor aut libusandae non num est ad				esectur me deliqui				aut optato.Tat prem quiduci endebis por maio temquo.</p>		</div>	</div></div><div class="csc-default col-xs-12 col-md-4">	<div class="image-box">		<div class="image"		     style="background-image: url(/fileadmin/_processed_/2/a/csm_haus_alpen_77ade93d3c.jpg);"></div>	</div></div><div class="csc-default col-xs-12 col-md-4">	<div class="event-box colored main">		<h3>Event</h3>		<p class="date">			<span class="day">25</span>			<span class="month">November</span>			<span class="year">2017</span>		</p>		<p class="text">67. Kongress für das internationale Badewesen 2017 aut dolor aut libusandae non num est ad			esectur me deliqui			aut optato.Tat prem quiduci endebis por maio temquo.</p>	</div></div></div>',
							'<div style="display: none;"><div class="csc-default col-xs-12 col-md-4">	<div class="event-box with-image">		<div class="image"		     style="background-image: url(/fileadmin/images/bilder/haus_alpen.jpg);"></div>		<h3>Event</h3>		<p class="date">			<span class="day">25</span>			<span class="month">November</span>			<span class="year">2017</span>		</p>		<p class="text">67. Kongress für das internationale Badewesen</p>	</div></div><div class="csc-default col-xs-12 col-md-4">	<div class="quote-box">		<h3>Symposium</h3>		<h2>Acocum cideli lorem uga uritati nobis busadia</h2>		<p class="quote">„Fea diorem. Occaectas aliciam quam nobis guter voluptatia vel maiorum quas a qui rae es. Eum			eos exeri aut commolu aut incipit quaspedior moluptibus.“</p>	</div></div><div class="csc-default col-xs-12 col-md-4">	<div class="theme-box colored main">		<h3>Symposium</h3>		<h2>Acocum cideli lorem uga uritati nobis busadia</h2>		<p class="text">Fea diorem. Occaectas unt aliciam quam nobis voluptatia vel maiorum quasa qui quam nobis			voluptatia frgvel maiorum vent et qua.</p>	</div></div></div>',
							'<div style="display: none;"><div class="csc-default col-xs-12 col-md-4">	<div class="quote-box">		<h3>Symposium</h3>		<h2>Acocum cideli lorem uga uritati nobis busadia</h2>		<p class="quote">„Fea diorem. Occaectas aliciam quam nobis guter voluptatia vel maiorum quas a qui rae es. Eum			eos exeri aut commolu aut incipit quaspedior moluptibus.“</p>	</div></div><div class="csc-default col-xs-12 col-md-4">	<div class="theme-box colored main">		<h3>Symposium</h3>		<h2>Acocum cideli lorem uga uritati obis busadia</h2>		<p class="text">Fea diorem. Occaectas unt aliciam quam nobis voluptatia vel maiorum uasa qui quam nobis			voluptatia frgvel maiorum vent et qua.</p>	</div></div><div class="csc-default col-xs-12 col-md-4">	<div class="theme-box colored">		<h3>Symposium</h3>		<h2>Acocum cideli lorem uga uritati nobis busadia</h2>		<p class="text">Fea diorem. Occaectas unt liciam quam nobis voluptatia vel maiorum quasa qui quam nobis			voluptatia frgvel maiorum vent et ua.</p>	</div></div></div>'];

				pasteContainer.append(contentInsert[Math.floor(((Math.random() / 2) * 10))]).children('div').each(function () {
					var self = $(this);

					if (!self.is(':visible')) {
						self.fadeIn('slow', function () {
							App.contentElementAnimations();
						});
					}
				});
			});


		},

		changePaddingTop: function () {
			$('#homepage').css('padding-top', glob.winH - glob.navH);
		},

		formatFilesize: function (bytes, si) {
			var thresh = si ? 1000 : 1024;
			if (Math.abs(bytes) < thresh) {
				return bytes + ' B';
			}
			var units = si
				? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
				// : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
				: ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
			var u = -1;
			do {
				bytes /= thresh;
				++u;
			} while (Math.abs(bytes) >= thresh && u < units.length - 1);
			return bytes.toFixed(1) + ' ' + units[u];
		}
	};
	Cookieman = {
		init: function(){
			$('.cookie-btn-accept').click(function(){

				$('.cookie-options').removeClass('d-none');
			});

			if (this.getCookie('CookieConsent')){
				$('.cookie-options').removeClass('d-none');
			};
		},

		getCookie: function (cname) {
			var name = cname + "=";
			var decodedCookie = decodeURIComponent(document.cookie);
			var ca = decodedCookie.split(';');
			for(var i = 0; i <ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
				}
			}
			return "";
		}
	};
	BookmarkHandling = {
		init: function () {
			var cookieName = 'bookmark',
				tdaBookmark = $('#tda_bookmark'),
				changeView = $('.change-view');

			BookmarkHandling.setBookmark();

			tdaBookmark.find('.remove-bookmark').click(function () {
				var self = $(this),
					project = self.data('project');

				Cookies.remove(cookieName, project);
				self.parent('.row').slideUp('slow', function () {
					var selfItem = $(this);
					selfItem.remove();
				});
				$('#project-list').find('#li_' + project).slideUp('slow', function () {
					var selfItem = $(this);
					selfItem.remove();
				});
			});

			changeView.click(function (e) {
				e.preventDefault();
				var self = $(this),
					selfView = self.data('view'),
					listProjects = $('.listProjects');

				if (selfView === 'detail') {
					listProjects.addClass('detail');
					// $('.change-view[data-view="detail"]').parent().slideUp('slow');
					// $('.change-view[data-view="list"]').parent().slideDown('slow');
					$('.change-view[data-view="detail"]').parent().addClass('hide');
					$('.change-view[data-view="list"]').parent().removeClass('hide');
				} else {
					listProjects.removeClass('detail');
					// $('.change-view[data-view="list"]').parent().slideUp('slow');
					// $('.change-view[data-view="detail"]').parent().slideDown('slow');
					$('.change-view[data-view="list"]').parent().addClass('hide');
					$('.change-view[data-view="detail"]').parent().removeClass('hide');
				}
			});
		},
		addBookmark: function () {
			var cookieName = 'bookmark';
			var addBookmark = $('.add-bookmark');

			addBookmark.click(function () {
				var self = $(this),
					project = self.data('project'),
					bookmarks = Cookies.get(cookieName);

				if ($.inArray(String(project), bookmarks) >= 0) {
					Cookies.remove(cookieName, project);
					$('.add-bookmark[data-project="' + project + '"]').removeClass('active').html('Merken <i class="glyphicon glyphicon-pushpin"></i>');
				} else {
					Cookies.add(cookieName, project);
					$('.add-bookmark[data-project="' + project + '"]').addClass('active').html('aus meiner Merkliste entfernen <i class="glyphicon glyphicon-pushpin"></i>');
				}
			});
		},
		setBookmark: function () {
			var cookieName = 'bookmark',
				bookmarks = Cookies.get(cookieName);

			for (var i = 0; i < bookmarks.length; i++) {
				$('.add-bookmark[data-project="' + bookmarks[i] + '"]').addClass('active').html('aus meiner Merkliste entfernen <i class="glyphicon glyphicon-pushpin"></i>');
			}
		}
	};

	/**
	 * New Event Handling - Start
	 * @todo detach completely from news handling
	 *
	 * @type {{init: init, handleEducation: handleEducation, handleEvents: handleEvents, handleAip: handleAip, specialCaseAV: specialCaseAV, setAnerkannt: setAnerkannt, extraFilter: extraFilter, changeButtonStats: changeButtonStats, setFilter: setFilter, setOptions: setOptions, setTagFilter: setTagFilter, setTagOptions: setTagOptions, applyTagFilter: applyTagFilter, getFilterButtonStates: (function(*): *), setFilterButtonStates: setFilterButtonStates}}
	 */
	EventHandling = {
		/**
		 * Init Function
		 */
		init: function () {
			var loadMore = $('.load-more');
			// console.log(glob);
			// If page ist not Newsroom
			if (glob.isNotNews) {
				// console.log('is not news');
				EventHandling.setTagFilter();
				EventHandling.setFilter();
			}
			// If page is Education
			if (glob.isFortbildung) {
				// console.log('is fortbildung');
				EventHandling.handleEducation();
				EventHandling.specialCaseAV();
				EventHandling.setOptions();
				EventHandling.extraFilter();
				loadMore.hide();
			}
			// If page is Event
			if (glob.isVeranstaltung) {
				// console.log('is veranstaltung');
				EventHandling.handleEvents();
				EventHandling.setOptions();
				EventHandling.extraFilter();
				loadMore.hide();
			}
			// if Page is AIP
			if (glob.isAip) {
				// console.log('is aip');
				EventHandling.handleAip();
				loadMore.hide();
			}
		},
		/**
		 * Handling of Education Page
		 */
		handleEducation: function () {
			// console.log('handle education');
			var eventFilter = $('#news-filter'),
				filterButtons = $('#news-filter > div'),
				eventOptions = $('.event-filter'),
				optionButtons = eventOptions.find('input[type="checkbox"]');

			// if some one of the filter-buttons is clicked, the filter-button state is updating,
			// the local storage is updating and the filters are set
			filterButtons.click(function () {
				var self = $(this);
				EventHandling.changeButtonStats(self);

				EventHandling.applyTagFilter();
				EventHandling.setFilter();
			});

			// if some of the option-buttons is clicked, the option-button state is updating and the options are set
			optionButtons.click(function () {
				var self = $(this);
				EventHandling.changeButtonStats(self);

				EventHandling.setOptions(true);
			});
		},
		/**
		 * Handeling of the events page
		 */
		handleEvents: function () {
			// console.log('handle events');
			var eventFilter = $('#news-filter'),
				filterButtons = $('#news-filter > div'),
				eventOptions = $('.event-filter'),
				optionButtons = eventOptions.find('input[type="checkbox"]');

			// if some one of the filter-buttons is clicked, the filter-button state is updating,
			// the local storage is updating and the filters are set
			filterButtons.click(function () {
				var self = $(this);
				EventHandling.changeButtonStats(self);

				EventHandling.applyTagFilter();
				EventHandling.setFilter();
			});

			// if some of the option-buttons is clicked, the option-button state is updating and the options are set
			optionButtons.click(function () {
				var self = $(this);
				EventHandling.changeButtonStats(self);

				EventHandling.setOptions(true);
			});
		},
		/**
		 * Handling of AIP Page
		 */
		handleAip: function () {
			// console.log('handle aip');
			var eventFilter = $('#news-filter'),
				filterButtons = $('#news-filter > div');

			// if some one of the filter-buttons is clicked, the filter-button state is updating,
			// the local storage is updating and the filters are set
			filterButtons.click(function () {
				var self = $(this);
				EventHandling.changeButtonStats(self);

				EventHandling.applyTagFilter();
				EventHandling.setFilter();
			});
		},

		/**
		 * Special case "Anerkannte Veranstaltungen"
		 */
		specialCaseAV: function () {
			// console.log('special case av');
			var avButton = $('#anerkannt'),
				exButton = $('.event-filter #extern'),
				inButton = $('.event-filter #intern'),
				articles = $('.news-list-view').children('.news-inner-list').children('.article');

			if (EventHandling.getAnerkanntState()) avButton.addClass('btn-primary');
			else avButton.removeClass('btn-primary');
			var avActive = (!!avButton.hasClass('btn-primary'));

			if (!avButton.hasClass('btn-primary') && !exButton.hasClass('btn-primary') && !inButton.hasClass('btn-primary')) {
				avActive = true;
			}

			EventHandling.setAnerkannt(avActive);

			avButton.click(function () {
				// console.log('av click');
				EventHandling.changeButtonStats($(this));
				avActive = (!!avButton.hasClass('btn-primary'));
				EventHandling.setAnerkanntState(avActive);
				avActive = (!!avButton.hasClass('btn-primary'));
				if (!avButton.hasClass('btn-primary') && !exButton.hasClass('btn-primary') && !inButton.hasClass('btn-primary')) {
					avActive = true;
				}
				EventHandling.setAnerkannt(avActive);
				EventHandling.setOptions();
			});
		},

		/**
		 * Show "Anerkannte Veranstaltungen"
		 * @param avActive
		 */
		setAnerkannt: function (avActive) {
			// console.log('-----------------------------');
			// console.log('set anerkannt');
			// console.log(avActive);
			var articles = $('.news-list-view').children('.news-inner-list').children('.article'),
				buttonStates = {
					intern: $('.event-filter #intern').is(':checked'),
					extern: $('.event-filter #extern').is(':checked'),
					anerkannt: $('#anerkannt').hasClass('btn-primary')
				};

			// console.log(buttonStates);
			articles.each(function () {
				var self = $(this),
					selfTags = (self.data('tags').toString().indexOf(',') >= 0) ? self.data('tags').toString().split(',') : [self.data('tags').toString()],
					active = false, showArticle = false;

				// if ($.inArray("51", selfTags) >= 0)
				// console.log(showArticle);

				if (!buttonStates.anerkannt && !buttonStates.intern && !buttonStates.extern) showArticle = true;
				if ($.inArray("51", selfTags) >= 0 && buttonStates.anerkannt && !buttonStates.intern && !buttonStates.extern) showArticle = true;
				if (!$.inArray("51", selfTags) >= 0 && !buttonStates.anerkannt && buttonStates.intern && buttonStates.extern) showArticle = true;
				if (!$.inArray("51", selfTags) >= 0 && !buttonStates.anerkannt && buttonStates.intern && !buttonStates.extern) showArticle = true;
				if (!$.inArray("51", selfTags) >= 0 && !buttonStates.anerkannt && !buttonStates.intern && buttonStates.extern) showArticle = true;
				if (buttonStates.anerkannt && buttonStates.intern && !buttonStates.extern) showArticle = true;
				if (buttonStates.anerkannt && !buttonStates.intern && buttonStates.extern) showArticle = true;
				if (buttonStates.anerkannt && buttonStates.intern && buttonStates.extern) showArticle = true;

				if ($.inArray("51", selfTags) >= 0 && !buttonStates.anerkannt && !buttonStates.intern && buttonStates.extern) showArticle = false;
				if ($.inArray("51", selfTags) >= 0 && !buttonStates.anerkannt && buttonStates.intern && buttonStates.extern) showArticle = false;
				if ($.inArray("51", selfTags) >= 0 && !buttonStates.anerkannt && buttonStates.intern && !buttonStates.extern) showArticle = false;

				// if ($.inArray("51", selfTags) >= 0)
				// console.log(showArticle);

				if (!glob.isFortbildung) showArticle = true;

				if (showArticle)
					self.removeClass('hide-anerkannt');
				else if (!showArticle)
					self.addClass('hide-anerkannt');


				// for (var i = 0; i < selfTags.length; i++) {
				// 	var selfTag = parseInt(selfTags[i]);
				// 	if (selfTag === 51 && showArticle) {
				// 		self.removeClass('hide-anerkannt');
				// 	} else if (selfTag === 51 && !showArticle) {
				// 		self.addClass('hide-anerkannt');
				// 	}
				// }
			});
		},

		/**
		 * Extra filter handling
		 */
		extraFilter: function () {
			// console.log('extra filter');
			var extraFilterButton = $('#extra-filter-button'),
				extraFilters = $('#extra-filters'),
				submitButton = extraFilters.find('button.submit-button'),
				resetButton = extraFilters.find('button.reset-button'),

				area = $('#form-event-zip').val(),
				subjectAreas = $('#form-event-subject-areas').val(),
				credits = $('#form-event-credits').val();

			if (area != '' || ((subjectAreas != '0' && subjectAreas != undefined) && subjectAreas != undefined) || (credits != '0' && credits != undefined)) {
				extraFilterButton.addClass('btn-primary');
				$('#extra-filters').show();
			}

			extraFilterButton.click(function () {
				var self = $(this);
				EventHandling.changeButtonStats(self);
				EventHandling.activateExtraFilter(self);
			});

			resetButton.click(function (e) {
				e.preventDefault();
				EventHandling.resetFilter();
			});
		},

		/**
		 * activate the extra filter fields
		 * @param extraButton
		 */
		activateExtraFilter: function (extraButton) {
			// console.log('handle education');
			var targetId = '#extra-filters';
			if (extraButton.hasClass('btn-primary')) {
				$(targetId).slideDown();
			} else {
				$(targetId).slideUp();
			}
		},

		/**
		 * Reset the extra filter
		 */
		resetFilter: function () {
			// console.log('reset');
			$('#form-event-zip').val('');
			$('#form-event-area').val('');
			$('#form-event-subject-areas').val('');
			$('#form-event-credits').val('');

			$('#form_event_area_chosen .chosen-single span').text('50 km');
			$('#form_event_subject_areas_chosen .chosen-single span').text('Keine Einschränkung');
			$('#form_event_credits_chosen .chosen-single span').text('Keine Einschränkung');

			$('#filter-form-felist').submit();
		},

		/**
		 * Change Filter Button Stats on every page (self classes needed)
		 * @param btn
		 */
		changeButtonStats: function (btn) {
			// console.log('change button state');
			if (btn.hasClass('btn-primary')) btn.removeClass('btn-primary');
			else btn.addClass('btn-primary');
		},
		/**
		 * Filter Articles of every page (classes!) - Uses #news-filter
		 */
		setFilter: function () {
			// console.log('set filter');
			var activeFilters = $('#news-filter > div.btn-primary'),
				articles = $('.news-list-view').children('.news-inner-list').children('.article'),
				avButton = $('#anerkannt'),
				avActive = (!!avButton.hasClass('btn-primary')),
				activeUids = [];

			activeFilters.each(function () {
				var self = $(this);
				activeUids.push(self.data('tag-uid'));
			});

			articles.each(function () {
				var self = $(this),
					selfTags = (self.data('tags').toString().indexOf(',') >= 0) ? self.data('tags').toString().split(',') : [self.data('tags').toString()],
					active = false,
					sonderPups = false;

				for (var i = 0; i < selfTags.length; i++) {
					var selfTag = parseInt(selfTags[i]);

					if ($.inArray(selfTag, activeUids) >= 0) {
						active = true;
					}
					if (selfTag === 51 && $.inArray(51, activeUids) === -1 && !avActive) sonderPups = true;
				}

				// sonderpups
				if (activeUids.length === 0)
					active = true;
				if (sonderPups) self.addClass('hide-anerkannt');


				if (active) {
					self.removeClass('hide-tags');
				} else {
					self.addClass('hide-tags');
				}
			});
		},

		/**
		 * Filter Articles of every page (classes!) - Uses .event-filter
		 * @param $click
		 */
		setOptions: function ($click) {
			// console.log('set options');
			var eventOptions = $('.event-filter'),
				avButton = $('#anerkannt'),
				avButtonState = avButton.hasClass('btn-primary'),
				filterButtons = eventOptions.find('input[type="checkbox"]'),
				stateType = (glob.isFortbildung) ? 'F' : 'V',
				buttonStates = EventHandling.getFilterButtonStates(stateType),

				articles = $('.news-list-view').children('.news-inner-list').children('.article'),
				activeUids = [];

			if (buttonStates === null) {
				if (glob.isFortbildung) buttonStates = {intern: true, extern: false};
				else if (glob.isVeranstaltung) buttonStates = {intern: true, extern: false};
				else buttonStates = {intern: false, extern: false};
			}
			if ($click) {
				filterButtons.each(function () {
					var self = $(this),
						selfId = self.attr('id'),
						selfChecked = self.is(':checked');

					buttonStates[selfId] = selfChecked;
				});
			}

			if (buttonStates.intern) activeUids.push($('.event-filter #intern').data('value'));
			if (buttonStates.extern) activeUids.push($('.event-filter #extern').data('value'));

			EventHandling.setFilterButtonStates(buttonStates, stateType);
			EventHandling.setTagOptions();

			if (!avButton.hasClass('btn-primary') && !buttonStates.intern && !buttonStates.extern) {
				avButtonState = true;
			}
			EventHandling.setAnerkannt(avButtonState);

			articles.each(function () {
				var self = $(this),
					selfTags = (self.data('tags').toString().indexOf(',') >= 0) ? self.data('tags').toString().split(',') : [self.data('tags').toString()],
					selfId = self.data('starting');

				if ($.inArray(selfId, activeUids) >= 0 || (avButtonState && $.inArray("51", selfTags) >= 0))
					self.removeClass('hide-cat');
				else
					self.addClass('hide-cat');
				if (activeUids.length === 0) self.removeClass('hide-cat');
				if ($.inArray(55, activeUids) >= 0 && $.inArray('60', selfTags) >= 0 && $.inArray(62, activeUids) < 0) self.addClass('hide-cat');
				if (selfId == 55 && $.inArray('60', selfTags) >= 0 && $.inArray(62, activeUids) >= 0) self.removeClass('hide-cat');
			});
		},

		/**
		 * activates the filter buttons
		 */
		setTagFilter: function () {
			// console.log('set tag filter');
			if (window.localStorage.getItem("newsFilter") !== null) {
				var eventFilter = JSON.parse(window.localStorage.getItem("newsFilter"));

				for (var i = 0; i < eventFilter.length; i++) {
					$('div[data-tag-uid="' + eventFilter[i] + '"]').addClass('btn-primary');
				}
			}
		},

		/**
		 * activates the option buttonshide-anerkannt
		 */
		setTagOptions: function () {
			// console.log('set tag options');
			var stateType = (glob.isFortbildung) ? 'F' : 'V';
			if (window.localStorage.getItem('filterButtonStates' + stateType) !== null) {
				var eventOption = JSON.parse(window.localStorage.getItem('filterButtonStates' + stateType));

				$('.event-filter #intern').attr('checked', eventOption.intern);
				$('.event-filter #extern').attr('checked', eventOption.extern);
			}
		},

		/**
		 * add filter to local storage
		 */
		applyTagFilter: function () {
			// console.log('apply tag filter');
			var actFilter = [],
				filter = $('#news-filter div, #anerkannt');

			filter.each(function () {
				var self = $(this);

				if (self.hasClass('btn-primary')) {
					actFilter.push(self.data('tag-uid'));
				}
			});

			window.localStorage.setItem('newsFilter', JSON.stringify(actFilter));
		},

		/**
		 * Get Filterbutton States (intern/extern)
		 * @param stateType
		 * @returns {*}
		 */
		getFilterButtonStates: function (stateType) {
			// console.log('get filter button states');
			return JSON.parse(window.localStorage.getItem('filterButtonStates' + stateType));
		},
		/**
		 * Set Filterbutton States (intern/extern)
		 * @param buttonStates
		 * @param stateType
		 */
		setFilterButtonStates: function (buttonStates, stateType) {
			// console.log('set filter button states');
			window.localStorage.setItem('filterButtonStates' + stateType, JSON.stringify(buttonStates));
		},

		/**
		 * Set "Anerkannt" states (sonderpups)
		 * @returns {*}
		 */
		getAnerkanntState: function () {
			// console.log('get anerkannte state');
			return JSON.parse(window.localStorage.getItem('anerkannt'));
		},
		/**
		 * Get "Anerkannt" states (sonderpups)
		 */
		setAnerkanntState: function (avActive) {
			// console.log('set anerkannte state');
			avActive = avActive || false;
			window.localStorage.setItem('anerkannt', avActive);
		}
	};
	// ############################################################################################
	// New Event Handling - End
	// ############################################################################################

	FormHandling = {
		init: function () {
			var street = $('input[name*="[project][street]"]'),
				zip = $('input[name*="[project][zip]"]'),
				city = $('input[name*="[project][city]"]'),
				filterFormProjectlist = $('#filter-form-projectlist'),
				checkBoxes = $('input[type="checkbox"]');
			$('.tx-mpm-architektouren form').on('submit', function () {
				var selfForm = $(this);
				selfForm.find('input[type="submit"]').attr('disabled', true);
				selfForm.find('submit').attr('disabled', true);
				selfForm.find('button').attr('disabled', true);
			});

			var formCheckboxFav = $('input[id^="favourite"]');

			$('#imageEditForm #submit').click(function (e) {
				if (formCheckboxFav.is(':checked')) {
					formCheckboxFav.parent('.checkbox').removeClass('error');
				} else {
					e.preventDefault();
					formCheckboxFav.parent('.checkbox').addClass('error');
				}
			});

			var formCheckboxFoto2 = $('input[id^="foto2"]');

			$('#imageEditForm #submit').click(function (e) {
				if (formCheckboxFoto2.is(':checked')) {
					formCheckboxFoto2.parent('.checkbox').removeClass('error');
				} else {
					e.preventDefault();
					formCheckboxFoto2.parent('.checkbox').addClass('error');
				}
			});

			if ($('#tda-view-filter').length > 0) {
				var tdaViewFilter = $('#tda-view-filter');

				tdaViewFilter.find('.sorting').each(function () {
					var self = $(this);

					self.click(function () {
						$('#tda-view-filter').find('.sorting').removeClass('active');
						self.addClass('active');

						glob.debug(tdaViewFilter.find('[name="sorting"]'));
						if (tdaViewFilter.find('[name*="sorting"]').length > 0) {
							tdaViewFilter.find('[name*="sorting"]').val(self.data("value"));
						} else {
							tdaViewFilter.find('form').append('<input type="hidden" name="tx_mpmarchitektouren_feprojectlist[sorting]" value="' + self.data("value") + '"/>');
						}
						tdaViewFilter.find('form').submit();
					});
				});
			}


			if (filterFormProjectlist.length > 0) {
				var filterSelect = filterFormProjectlist.find('select'),
					filterCheckbox = filterFormProjectlist.find('input[type="checkbox"]');

				filterSelect.on('change', function () {
					window.localStorage.setItem($(this).attr('name'), $(this).val());
					filterFormProjectlist.submit();
				});
				filterCheckbox.on('change', function () {
					if ($(this).is(':checked')) {
						window.localStorage.setItem($(this).attr('name'), 1);
					} else {
						window.localStorage.setItem($(this).attr('name'), 0);
					}
					filterFormProjectlist.submit();
				});
			}

			FormHandling.adminPanel();
			FormHandling.validation();
			if ($('textarea[name="tx_mpmarchitektouren_project[project][description]"]').length > 0)
				FormHandling.checkProjectDescription($('textarea[name="tx_mpmarchitektouren_project[project][description]"]'));
			var inputAcceptConditions = $('input[id^="acceptConditions"]');
			FormHandling.checkConditions(inputAcceptConditions);
			inputAcceptConditions.change(function () {
				FormHandling.checkConditions(inputAcceptConditions);
			});

			street.blur(function () {
				FormHandling.addCoordinates();
			});
			zip.blur(function () {
				FormHandling.addCoordinates();
			});
			city.blur(function () {
				FormHandling.addCoordinates();
			});

			FormHandling.addCoordinates();

			var formCheckboxFav = $('input[id^="favourite"]');
			formCheckboxFav.change(function () {
				var selfClick = $(this);

				formCheckboxFav.each(function () {
					var selfCB = $(this);

					if (selfClick.attr('id') != selfCB.attr('id')) {
						selfCB.attr('checked', false);
					}
				});
			});

			var formCheckboxFoto2 = $('input[id^="foto2"]');
			formCheckboxFoto2.change(function () {
				var selfClick = $(this);

				formCheckboxFoto2.each(function () {
					var selfCB = $(this);

					if (selfClick.attr('id') != selfCB.attr('id')) {
						selfCB.attr('checked', false);
					}
				});
			});

			var formCheckboxTransfer = $('.transfer');
			formCheckboxTransfer.click(function () {
				var selfClick = $(this),

					selfGender = selfClick.parents('.imageFormFields').find('[name*="gender"]').val(),
					selfFirstname = selfClick.parents('.imageFormFields').find('[name*="FirstName"]').val(),
					selfLastname = selfClick.parents('.imageFormFields').find('[name*="LastName"]').val(),
					selfFotostudio = selfClick.parents('.imageFormFields').find('[name*="StudioName"]').val(),
					selfZip = selfClick.parents('.imageFormFields').find('[name*="Zip"]').val(),
					selfCity = selfClick.parents('.imageFormFields').find('[name*="City"]').val(),
					selfCountry = selfClick.parents('.imageFormFields').find('[name*="Country"]').val();

				if (confirm('Wollen Sie die Fotografendaten auf alle Bilder übertragen? Bitte geben Sie im Anschluss die Bildtitel einzeln ein.')) {
					formCheckboxTransfer.each(function () {
						var selfCB = $(this);

						if (selfClick.attr('id') != selfCB.attr('id')) {
							selfCB.parents('.imageFormFields').find('[name*="gender"]').val(selfGender).trigger('chosen:updated');
							selfCB.parents('.imageFormFields').find('[name*="FirstName"]').val(selfFirstname);
							selfCB.parents('.imageFormFields').find('[name*="LastName"]').val(selfLastname);
							selfCB.parents('.imageFormFields').find('[name*="StudioName"]').val(selfFotostudio);
							selfCB.parents('.imageFormFields').find('[name*="Zip"]').val(selfZip);
							selfCB.parents('.imageFormFields').find('[name*="City"]').val(selfCity);
							selfCB.parents('.imageFormFields').find('[name*="Country"]').val(selfCountry).trigger('chosen:updated');
							// FormHandling.changeZipValidation();
						}
					});
				}
			});

			$('.chosen-select').chosen({
				disable_search_threshold: 200,
				inherit_select_classes: true,
				width: '100%'
			});

			$('.chosen-select-multi').chosen({
				inherit_select_classes: true,
				width: '100%'
			});

			$('.chosen-container').removeClass('validate[required]');

			$('.delete').click(function () {
				if (!confirm('Soll der Datensatz wirklich gelöscht werden?')) {
					return false;
				}
			});

			$('.finish').click(function () {
				if (!confirm('Wollen Sie die Anmeldung wirklich abschließen?')) {
					return false;
				}
			});

			$('.cancel').click(function () {
				if (!confirm('Wollen Sie wirklich zurück zur Liste? Alle Änderungen gehen dabei verloren.')) {
					return false;
				}
			});
			$('input[id^="www"]').on('change', function () {
				var self = $(this),
					selfVal = self.val();

				if (selfVal && selfVal.indexOf('http://') == -1 && selfVal.length > 0) {
					self.val('http://' + selfVal);
				}
			});

			$('input[id^="facebook"]').on('change', function () {
				var self = $(this),
					selfVal = self.val();

				if (selfVal && selfVal.indexOf('/') == -1 && selfVal.length > 0) {
					self.val('/' + selfVal);
				}
			});

			$('input[id^="instagram"]').on('change', function () {
				var self = $(this),
					selfVal = self.val();

				if (selfVal && selfVal.indexOf('/') == -1 && selfVal.length > 0) {
					self.val('/' + selfVal);
				}
			});
			FormHandling.handleAltField();
			$('[data-toggle="tooltip"]').tooltip();

			if ($('#noMoreEmployees').length > 0) {
				FormHandling.checkboxSubmit($('#noMoreEmployees'));
			}
			if ($('#noMoreAssociates').length > 0) {
				FormHandling.checkboxSubmit($('#noMoreAssociates'));
			}
			if ($('#noMoreUsers').length > 0) {
				FormHandling.checkboxSubmit($('#noMoreUsers'));
			}
			if ($('.isBuilder').length > 0) {
				FormHandling.checkboxSubmit($('.isBuilder'));
			}
			if ($('.hasWorkgroup').length > 0) {
				FormHandling.checkboxSubmit($('.hasWorkgroup'));
			}
			if ($('.isUser').length > 0) {
				FormHandling.checkboxSubmit($('.isUser'));
			}

			checkBoxes.click(function () {
				var self = $(this);

				if (self.is(':checked')) {
					self.parents('.checkbox').find('.extra-field').stop(true).slideDown('slow');
				} else {
					self.parents('.checkbox').find('.extra-field').stop(true).slideUp('fast');
				}
			});

			$('form').submit(function () {
				var selfForm = $(this),
					files = false,
					maxSize = 10485760,
					fileSizes = 0,
					state = false;

				if (selfForm.find('input[type="file"]').length) {
					files = $('input[type="file"]').prop('files');

					if (files) {
						for (var i = 0; i < files.length; i++) {
							fileSizes += files[i].size;
						}

						if (fileSizes > maxSize) {
							state = PopupLink.alert("Die Maximale Dateigröße von <b>" + App.formatFilesize(maxSize, false) + "</b> wurde mit <b>" +
								App.formatFilesize(fileSizes, false) + "</b> um <b>" + App.formatFilesize((fileSizes - maxSize), false) + "</b> überschritten.", 'warning');

							if (state > 1) {
								return false;
							}
						}
					}
				}
			});

			$('input[type="file"]').bind('change', function () {
				var files = this.files,
					maxSize = 10485760,
					fileSizes = 0,
					state = false;
				$('.actual_size').remove();

				for (var i = 0; i < files.length; i++) {
					fileSizes += files[i].size;
				}

				var sizeWarn = ' success';
				if (fileSizes >= maxSize) {
					sizeWarn = ' error';
				} else if (fileSizes < maxSize && fileSizes > (maxSize * .9)) {
					sizeWarn = ' warn';
				}
				$(this).after('<p class="actual_size' + sizeWarn + '"><b>' + App.formatFilesize(fileSizes, false) + '</b> von Max. <b>' + App.formatFilesize(maxSize, false) + '</b></p>');

				$('.fileinput-remove').click(function () {
					var self = $(this),
						fileUploadBtn = self.parent().find('.actual_size');
					fileUploadBtn.remove();
				});
			});
			// FormHandling.changeZipValidation();
		},

		changeZipValidation: function () {
			$('input[name*="[zip]"],input[name*="[photoStudioZip]"]').each(function () {
				var self = $(this);
				self.attr('data-class', self.attr('class'));
			});
			var country = $('select[name*="[country]"],select[name*="[photoStudioCountry]"]');

			country.each(function () {
				var self = $(this),
					selfVal = self.val() || 0,
					selfId = self.attr('id'),
					selfIdArray = selfId.split('-'),
					selfId1 = selfIdArray[1],
					selfId2 = selfIdArray[2],
					validations = ['zip', 'zipDE', 'zipFR', 'zipLB', 'zipNL', 'zipAT', 'zipCH', 'zipBE', 'zipDK', 'zipSE'],

					zipField = $('#zip-' + selfId1 + '-' + selfId2 + ',#photoStudioZip-' + selfId1 + '-' + selfId2 + ''),
					zipFieldClass = zipField.data('class');
				if (zipField.length > 0) zipField.attr('class', zipFieldClass.replace('custom[zip]', 'custom[' + validations[selfVal] + ']'));
			});
			country.change(function () {
				var self = $(this),
					selfVal = self.val() || 0,
					selfId = self.attr('id'),
					selfIdArray = selfId.split('-'),
					selfId1 = selfIdArray[1],
					selfId2 = selfIdArray[2],
					validations = ['zip', 'zip', 'zipFR', 'zipLB', 'zipNL', 'zipAT', 'zipCH', 'zipBE', 'zipDK', 'zipSE'],

					zipField = $('#zip-' + selfId1 + '-' + selfId2 + ',#photoStudioZip-' + selfId1 + '-' + selfId2 + ''),
					zipFieldClass = zipField.data('class');

				if (zipField.length > 0) zipField.attr('class', zipFieldClass.replace('custom[zip]', 'custom[' + validations[selfVal] + ']'));
			});
		},

		addCoordinates: function () {
			if ($('input[name*="[project][street]"]').length > 0) {
				var street = $('input[name*="[project][street]"]').val(),
					zip = $('input[name*="[project][zip]"]').val(),
					city = $('input[name*="[project][city]"]').val();

				var ajaxString = "https://nominatim.openstreetmap.org/search/" +
					encodeURIComponent(street + ' ' + zip + ' ' + city) + "?format=json&limit=1&polygon_svg=1";

				$.ajax({
					type: "GET",
					dataType: "text",
					url: ajaxString,
					success: function (d) {
						var data = JSON.parse(d);
						if (data.length > 0) {
							$('input.lat').val($.trim(data[0]['lat']));
							$('input.lng').val($.trim(data[0]['lon']));
						}
					}
				});
			}
		},

		adminPanel: function () {
			var adminPanel = $('#adminOptions'),
				adminButton = adminPanel.find('.adminOpenButton'),
				adminForm = adminPanel.find('form'),
				submitButtonWrap = adminForm.find('div.submit-button');

			adminButton.click(function () {
				if (!adminPanel.hasClass('opened')) {
					adminButton.find('.glyphicon').removeClass('glyphicon-cog').addClass('glyphicon-remove');
					adminPanel.stop(true).animate({
						right: 0
					}, 600, function () {
						adminPanel.addClass('opened');
						submitButtonWrap.css('right', 0);
						submitButtonWrap.stop(true).fadeIn('slow');
					});
				} else {
					submitButtonWrap.stop(true).fadeOut('fast', function () {
						submitButtonWrap.css('right', 0);
						adminPanel.stop(true).animate({
							right: -300
						}, 300, function () {
							adminPanel.removeClass('opened');
							adminButton.find('.glyphicon').removeClass('glyphicon-remove').addClass('glyphicon-cog');
						});
					});
				}
			});

			$('#option-button').click(function (e) {
				var self = $(this);
				self.find('label').html('<span class="loader"></span> Speichern...');
				self.prepend('<div class="button-overlay"></div>');
			});
		},

		checkboxSubmit: function ($input) {
			$input.click(function () {
				var self = $(this);
				self.parents('form').submit();
			});
		},

		checkConditions: function ($inputAcceptConditions) {
			if ($inputAcceptConditions.is(":checked")) {
				$('.afterCheckConditions').stop(true).fadeIn('slow', function () {
					FormHandling.checkProjectDescription($('textarea[name="tx_mpmarchitektouren_newproject[project][description]"]'));
				});
				$('#introtext_new_project').stop(true).slideUp('slow');
			} else {
				$('.afterCheckConditions').stop(true).fadeOut('slow');
				$('#introtext_new_project').stop(true).slideDown('slow');
			}
			FormHandling.checkTime();
		},

		checkTime: function () {
			var timeInput = $('select.time');
			timeInput.each(function () {
				var self = $(this),
					selfVal = self.val(),
					selfType = false,
					selfTimeFrom = $('.time-from[data-day="' + self.data('day') + '"]'),
					selfTimeTo = $('.time-to[data-day="' + self.data('day') + '"]'),
					otherDay = 'sunday';

				if (self.data('day') == 'sunday') {
					otherDay = 'saturday';
				}

				if (selfVal <= 0 && $('#introtext_new_project').length <= 0) {
					selfTimeTo.prop('disabled', true).val("0");
					$('.time-from[data-day="' + otherDay + '"] option[value=0]').prop('disabled', true);
					$('.time-to[data-day="' + otherDay + '"] option[value=0]').prop('disabled', true);
				}
				if (self.hasClass('time-from'))
					selfType = 'from';
				else
					selfType = 'to';

				if ($('#introtext_new_project').length > 0) {
					if (selfType == 'from' && self.data('day') == 'saturday')
						self.val("5");
					if (selfType == 'to' && self.data('day') == 'saturday')
						self.val("7");
					if (selfType == 'from' && self.data('day') == 'sunday')
						self.val("2");
					if (selfType == 'to' && self.data('day') == 'sunday')
						self.val("7");
				}

				self.change(function () {
					var selfT = $(this),
						selfTVal = selfT.val(),
						selfTType = false,
						day = selfT.data('day'),
						timeToOptions = $('.time-to[data-day="' + day + '"] option');

					if (selfTVal <= 0) {
						timeToOptions.prop('disabled', true);

						$('.time-from[data-day="' + otherDay + '"] option[value=0]').prop('disabled', true);
						$('.time-to[data-day="' + otherDay + '"] option[value=0]').prop('disabled', true);

						selfTimeTo.val("-1");
						selfTimeFrom.val(-1);
					} else {
						selfTimeTo.prop('disabled', false);

						$('.time-from[data-day="' + otherDay + '"] option[value=0]').prop('disabled', false);
						$('.time-to[data-day="' + otherDay + '"] option[value=0]').prop('disabled', false);

						if (selfTimeTo.val() <= 0)
							selfTimeTo.val(selfTVal);
					}

					if (selfT.hasClass('time-from'))
						selfTType = 'from';
					else
						selfTType = 'to';

					if (selfTType == 'from') {
						timeToOptions.prop('disabled', false);

						timeToOptions.each(function (idx, option) {
							var option = $(option);

							if (option.val() == selfTVal) {
								return false;
							}

							// disable all options before the chosen one in the "To" selector
							option.prop('disabled', true).prop("selected", false);
						});

						/*
						for (var i = 1; i < selfTVal; i++) {
							$('.time-to[data-day="' + day + '"] option[value="' + i + '"]').prop('disabled', true).prop("selected", false);
						}
						//*/

						if (selfTVal == 0) {
							timeToOptions.prop('disabled', true);
						}
					}

					$('select.time').trigger('chosen:updated');
				});

				$('select.time').trigger('chosen:updated');
			});
		},

		checkProjectDescription: function (description) {
			var max = 650,
				diff = max - description.val().length;
			updateText(diff, max);

			description.on('change keyup paste', function () {
				var self = $(this),
					selfVal = self.val(),
					diff = max - description.val().length;
				updateText(diff, max);

				if (selfVal.length > max) {
					self.val(selfVal.substring(0, max));
				}
			});

			function updateText($diff, $max) {
				var textLength = $('.textLength');
				if ($diff < 0) $diff = 0;
				if (textLength.length > 0) textLength.remove();
				description.after('<p class="textLength">Noch ' + $diff + ' von ' + $max + ' Zeichen.</p>');
				if ($diff <= max) description.next().css({color: 'green', fontWeight: 'bold'});
				if ($diff <= 150) description.next().css({color: 'orange', fontWeight: 'bold'});
				if ($diff <= 10) description.next().css({
					color: 'red',
					fontWeight: 'bold',
					textDecoration: 'underline'
				});
			}
		},

		handleAltField: function () {
			var allDDs = $('select[name*="[jobTitle]"],select[name*="[title]"],select[name*="[certificate]"],select[name*="[chamberOfArchitects]"]');

			allDDs.each(function () {
				var self = $(this),
					selfVal = self.val(),
					selfOpt = self.children('option'),
					altField = self.parent('div').next(),
					altFieldInput = altField.children('input');

				selfOpt.each(function () {
					var selfO = $(this),
						selfSel = selfO.is(':selected');
					if (selfSel) {
						if (selfO.text() == 'Sonstiges') {
							altField.css('display', 'block');
							if (altFieldInput.data('req')) {
								altFieldInput.addClass('validate[required]')
							}
						}
					}
				});
			});
			allDDs.change(function () {
				var self = $(this),
					selfVal = self.val(),
					selfOpt = self.children('option'),
					altField = self.parent('div').next(),
					altFieldInput = altField.children('input');

				selfOpt.each(function () {
					var selfO = $(this),
						selfSel = selfO.is(':selected');
					if (selfSel) {
						if (selfO.text() == 'Sonstiges') {
							altField.stop(true).fadeIn('slow');
							if (altFieldInput.data('req')) {
								altFieldInput.addClass('validate[required]')
							}
						} else {
							altField.stop(true).fadeOut('fast');
							if (altFieldInput.data('req')) {
								altFieldInput.removeClass('validate[required]')
							}
						}
					} else {
						altField.stop(true).fadeOut('fast');
						if (altFieldInput.data('req')) {
							altFieldInput.removeClass('validate[required]')
						}
					}
				});
			});
		},

		validation: function () {
			if ($('.final-form').length > 0) {
				$('form.final-form').validationEngine('attach', {
					scroll: false,
					onValidationComplete: function (form, status) {
						if (!status) {
							form.find('input[type="submit"]').attr('disabled', false);
							form.find('submit').attr('disabled', false);
							form.find('button').attr('disabled', false);
						} else {
							return true;
						}
					}
				});
			} else {
				$('form').validationEngine('attach', {
					validateNonVisibleFields: true,
					promptPosition: "inline",
					scroll: false,
					onValidationComplete: function (form, status) {
						if (!status) {
							form.find('input[type="submit"]').attr('disabled', false);
							form.find('submit').attr('disabled', false);
							form.find('button').attr('disabled', false);
						} else {
							return true;
						}
					}
				});
			}
		}
	};

	SideBar = {
		init: function () {
			SideBar.rightNavi();
			var sidebarButton = $('#sidebar-button'),
				sidebar = $('#sidebar-wrapper'),
				sidebarNav = $('.sidebar-nav'),
				sidebarCloseButton = sidebarNav.find('.close-menu'),
				sidebarNavSubmenu = $('.sidebar-nav.submenu'),
				sidebarNavLi = sidebarNav.children('li'),
				sidebarNavSubmenuLi = sidebarNavSubmenu.children('li');

			//SideBar.resize();
			//$(window).resize(function () {
			//	SideBar.resize();
			//});

			sidebarNavSubmenuLi.children('a').children('span.glyphicon').click(function (event) {
				event.preventDefault();
				var self = $(this).parent('a').parent('li'),
					sidebarSubNav = self.children('.sidebar-sub-nav'),
					glyph = self.find('.glyphicon');

				if (self.hasClass('opened')) {
					self.removeClass('opened');
					glyph.addClass('glyphicon-menu-down').removeClass('glyphicon-menu-up');
					sidebarSubNav.stop(true).slideUp('fast');
				} else {
					self.addClass('opened');
					glyph.addClass('glyphicon-menu-up').removeClass('glyphicon-menu-down');
					sidebarSubNav.stop(true).slideDown('slow');
				}
			});

			sidebarCloseButton.click(function () {
				if (sidebar.hasClass('opened')) {
					sidebar.stop(true).animate({
						right: -500
					}, 600, 'easeInOutBack', function ($data) {
						sidebar.removeClass('opened');
					});
				}
			});

			sidebarButton.click(function () {
				if (sidebar.hasClass('opened')) {
					sidebar.stop(true).animate({
						right: -500
					}, 600, 'easeInOutBack', function ($data) {
						sidebar.removeClass('opened');
					});
				} else {
					sidebar.stop(true).animate({
						right: 0
					}, 600, 'easeInOutBack', function ($data) {
						sidebar.addClass('opened');

					});
				}
			});
		},

		rightNavi: function () {
			var naviRight = $('.navigation_right > ul'),
				naviRightSubmenu = $('.navigation_right .sub-nav'),
				naviRightLi = naviRight.children('li'),
				naviRightSubmenuLi = naviRightSubmenu.children('li');

			naviRightLi.children('a').children('span.glyphicon').click(function (event) {
				event.preventDefault();
				var self = $(this).parent('a').parent('li'),
					sidebarSubNav = self.children('.sub-nav'),
					glyph = self.find('.glyphicon');

				if (self.hasClass('opened')) {
					self.removeClass('opened');
					glyph.addClass('glyphicon-menu-down').removeClass('glyphicon-menu-up');
					sidebarSubNav.stop(true).slideUp('fast');
				} else {
					self.addClass('opened');
					glyph.addClass('glyphicon-menu-up').removeClass('glyphicon-menu-down');
					sidebarSubNav.stop(true).slideDown('slow');
				}
			});
		},

		resize: function () {
			var header = $('#header'),
				sidebar = $('#sidebar-wrapper'),
				headerHeight = header.height();

			sidebar.height(headerHeight);
		}
	};

	DateTimePicker = {
		init: function () {
			$('.input-group.date').datetimepicker({
				locale: 'de',
				format: 'YYYY',
				useStrict: false,
				sideBySide: true,
				showClear: true,
				viewMode: 'years'
			});

			var jetzt = new Date();
			var Zeit = Math.floor(jetzt.getTime() / 1000);
			DateTimePicker.getEvents(Zeit);

			if ($('.calendar').length > 0) {
				$('.calendar').datetimepicker({
					locale: 'de',
					format: 'DD.MM.YYYY',
					inline: true,
					tooltips: {
						today: 'Gehe zu Heute',
						clear: 'Sektion leeren',
						close: 'Schließen',
						selectMonth: 'Monat wählen',
						prevMonth: 'Letzter Monat',
						nextMonth: 'Nächster Monat',
						selectYear: 'Jahr wählen',
						prevYear: 'Letztes Jahr',
						nextYear: 'Nächstes Jahr',
						selectDecade: 'Jahrzehnt wählen',
						prevDecade: 'Letztes Jahrzehnt',
						nextDecade: 'Nächstes Jahrzehnt',
						prevCentury: 'Letztes Jahrhundert',
						nextCentury: 'Nächstes Jahrhundert'
					}
				}).on('dp.change', function (event) {
					DateTimePicker.changeDatepickerMonth();
					var changedDate = new Date(event.date.format()),
						timestamp = changedDate.getTime() / 1000;

					DateTimePicker.getEvents(timestamp);
					DateTimePicker.getAllEvents();
					DateTimePicker.activeDay();

					$('.calendar .old').text('');
					$('.calendar .new').text('');
				}).on('dp.update', function (event) {
					DateTimePicker.changeDatepickerMonth();
					DateTimePicker.getAllEvents();
					$('.calendar .old').text('');
					$('.calendar .new').text('');
				}).on('dp.show', function (event) {
					DateTimePicker.changeDatepickerMonth();
					DateTimePicker.getAllEvents();
					$('.calendar .old').text('');
					$('.calendar .new').text('');
				}).on('dp.hide', function (event) {
					DateTimePicker.changeDatepickerMonth();
					DateTimePicker.getAllEvents();
					$('.calendar .old').text('');
					$('.calendar .new').text('');
				}).on('dp.error', function (event) {
					DateTimePicker.changeDatepickerMonth();
					DateTimePicker.getAllEvents();
					$('.calendar .old').text('');
					$('.calendar .new').text('');
				});
				$('.calendar .picker-switch').click(function (e) {
					e.preventDefault();
					return false;
				});
				$('.calendar .old').text('');
				$('.calendar .new').text('');

				DateTimePicker.getAllEvents();

				DateTimePicker.changeDatepickerMonth(true);
			}
		},

		changeDatepickerMonth: function ($firstInit) {
			// TODO: Schauen, ob das zusammen gehackte auch anders zu Lösen ist.
			var datePickerDay = $('#marginal-kalendar')
					.find('.calendar')
					.find('.datepicker')
					.find('.datepicker-days')
					.find('.table-condensed'),
				titleMonth = datePickerDay.find('.prev').html();

			if (!$firstInit) datePickerDay.find('.picker-switch').html(titleMonth);
			datePickerDay.find('.prev').before(datePickerDay.find('.picker-switch'))
				.html('<span class="glyphicon glyphicon-chevron-left" title="Letzter Monat"></span>').removeAttr('title');
		},

		getEvents: function ($timestamp) {
			var uri = window.location.protocol + '//' + window.location.host;
			var data =
				{
					"id": 313,
					"type": "6363",
					"tx_tgmlazynews_ajax[action]": "ajax",
					"tx_tgmlazynews_ajax[controller]": "News",
					"tx_tgmlazynews_ajax[timestamp]": $timestamp
				};

			$.ajax({
				type: "GET",
				dataType: "text",
				url: uri,
				data: data,
				success: function (d) {
					 console.log(d);
					$('#marginal-kalendar .events').html(d);
				}
			});
		},
		activeDay : function () {
				$('.calendar .day').on('click', function () {
					if($(this).hasClass('active')) {
						$(this).addClass('disabled');
					}
					else {
						$(this).removeClass('disabled');

					}
				});
		},

		getAllEvents: function () {
			var uri = window.location.protocol + '//' + window.location.host;
			var data =
				{
					"id": 313,
					"type": "6363",
					"tx_tgmlazynews_ajax[action]": "ajax",
					"tx_tgmlazynews_ajax[controller]": "News",
					"tx_tgmlazynews_ajax[getall]": true
				};

			$.ajax({
				type: "GET",
				dataType: "text",
				url: uri,
				data: data,
				success: function (d) {
					var obj = JSON.parse(d);
					for (var i = 0; i < obj.length; i++) {
						var dateNow = new Date(obj[i] * 1000),
							eventDate = DateTimePicker.fillDate(dateNow.getDate()) + '.' + DateTimePicker.fillDate(dateNow.getMonth() + 1) + '.' + dateNow.getFullYear();

						$('#marginal-kalendar .calendar .datepicker td[data-day="' + eventDate + '"]').addClass('event');
					}
				}
			});
		},

		fillDate: function ($date) {
			if ($date < 10) {
				return '0' + $date;
			}
			return $date;
		}
	};

	BootstrapFileInput = {
		init: function () {

			var minImages = 4,
				maxImages = 10,
				imagesCount = $('.project-image-count').data('images');
			if (imagesCount) {
				if (imagesCount < 4) {
					minImages = 4 - imagesCount;
				} else {
					minImages = 0;
				}
				if (imagesCount < 10) {
					maxImages = 10 - imagesCount;
				} else {
					maxImages = 0;
				}
			}

			$('input.projectimages').fileinput({
				language: "de",
				minImageWidth: 5000,
				minImageHeight: 4500,
				maxFileSize: 10240,
				allowedFileTypes: ["image"],
				previewFileType: "image",
				browseClass: "btn btn-darkgrey",
				browseLabel: "Bild wählen",
				browseIcon: "<i class=\"glyphicon glyphicon-picture\"></i> ",
				removeClass: "btn btn-darkgrey",
				removeLabel: "Löschen",
				removeIcon: "<i class=\"glyphicon glyphicon-trash\"></i> ",
				uploadClass: "btn btn-darkgrey",
				uploadLabel: "Hochladen",
				uploadIcon: "<i class=\"glyphicon glyphicon-upload\"></i> "
			});

			$('input.portrait').fileinput({
				language: "de",
				allowedFileTypes: ["image"],
				previewFileType: "image",
				browseClass: "btn btn-darkgrey",
				browseLabel: "Bild wählen",
				browseIcon: "<i class=\"glyphicon glyphicon-picture\"></i> ",
				removeClass: "btn btn-darkgrey",
				removeLabel: "Löschen",
				removeIcon: "<i class=\"glyphicon glyphicon-trash\"></i> ",
				uploadClass: "btn btn-darkgrey",
				uploadLabel: "Hochladen",
				uploadIcon: "<i class=\"glyphicon glyphicon-upload\"></i> ",
				maxFileCount: 1
			}).on('fileselect', function () {
				var self = $('.' + $(this).attr('id'));
				self.stop(true).fadeIn('slow');
				// self.find('[name*="gender"]').addClass('validate[required]');
				self.find('[name*="firstName"]').addClass('validate[required]');
				self.find('[name*="lastName"]').addClass('validate[required]');
				self.find('[name*="city"]').addClass('validate[required]');
				self.find('[name*="country"]').addClass('validate[required]');
			}).on('fileclear', function () {
				var self = $('.' + $(this).attr('id'));
				self.stop(true).fadeOut('fast');
				// self.find('[name*="gender"]').removeClass('validate[required]');
				self.find('[name*="firstName"]').removeClass('validate[required]');
				self.find('[name*="lastName"]').removeClass('validate[required]');
				self.find('[name*="city"]').removeClass('validate[required]');
				self.find('[name*="country"]').removeClass('validate[required]');
			});

			$('input.projectfiles').fileinput({
				language: "de",
				previewFileType: "image",
				browseClass: "btn btn-darkgrey",
				browseLabel: "Datei wählen",
				browseIcon: "<i class=\"glyphicon glyphicon-picture\"></i> ",
				removeClass: "btn btn-darkgrey",
				removeLabel: "Löschen",
				removeIcon: "<i class=\"glyphicon glyphicon-trash\"></i> ",
				uploadClass: "btn btn-darkgrey",
				uploadLabel: "Hochladen",
				uploadIcon: "<i class=\"glyphicon glyphicon-upload\"></i> "
			}).on('fileselect', function () {
				$('.' + $(this).attr('id')).stop(true).fadeIn('slow');
			}).on('fileclear', function () {
				$('.' + $(this).attr('id')).stop(true).fadeOut('fast');
			});
		}
	};

	BootstrapTable = {
		init: function () {
			////$('#table').tableExport({type:'csv'});
			//var $table = $('#table');
			//$('#toolbar').find('select').change(function () {
			//	$table.bootstrapTable('destroy').bootstrapTable({
			//		exportDataType: $(this).val()
			//	});
			//});

			// Data Table
			var dt;

			if ($('#tda2017_list').length > 0)
				dt = BootstrapTable.initDataTables($('#tda2017_list'));
			if ($('#tda2017_list_jury').length > 0)
				dt = BootstrapTable.initDataTables($('#tda2017_list_jury'), {
					"language": {
						"url": "//cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/German.json",
						buttons: {
							colvis: 'Spalten'
						}
					},
					order: [
						[0, 'asc']
					],
					"scrollY": "500px",
					"scrollX": true,
					"scrollCollapse": true,
					"lengthMenu": [
						[10, 25, 50, -1],
						[10, 25, 50, "All"]
					],
					dom: 'Bfrtip',
					buttons: [
						{
							extend: 'excelHtml5',
							title: 'tda2022_liste',
							exportOptions: {
								columns: ':visible'
							}
						},
						{
							extend: 'csvHtml5',
							title: 'tda2022_liste',
							exportOptions: {
								columns: ':visible'
							}
						}
					],
					responsive: true
				});
			var votingTable = $('#tda2017_list_voting');
			if (votingTable.length > 0) {
				var lastTh = votingTable.find('th:last'),
					index = (lastTh.data('voting-end')) ? lastTh.index() - 1 : lastTh.index();

				$('#resetVotingData').click(function ($e) {
					$e.preventDefault();
					if (confirm('Wollen Sie wirklich die Abstimmungs-Daten unwiederruflich zurück setzen?')) {
						window.location.href = $(this).attr('href');
					}
				});

				var orderings = [];
				for (var i = 0; i < index; i++) {
					orderings.push({
						"targets": i,
						"orderable": false
					});
				}
				if (lastTh.data('voting-end')) {
					orderings.push({
						"targets": index + 1,
						"orderable": false
					});
				}

				dt = BootstrapTable.initDataTables($('#tda2017_list_voting'), {
					"language": {
						"url": "//cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/German.json",
						buttons: {
							colvis: 'Spalten'
						}
					},
					"columnDefs": orderings,
					order: [
						[index, 'desc']
					],
					"scrollX": true,
					"scrollCollapse": true,
					"lengthMenu": [
						[-1],
						["All"]
					],
					dom: 'Bfrtip',
					buttons: [
						{
							extend: 'excelHtml5',
							title: 'tda2022_liste',
							exportOptions: {
								columns: ''
							}
						},
						{
							extend: 'csvHtml5',
							title: 'tda2022_liste',
							exportOptions: {
								columns: ''
							}
						},
						{
							extend: 'colvis',
							columns: ':not(:first-child)'
						}
					],
					responsive: true,
					paging: false,
					"drawCallback": function (settings) {
						var api = this.api();
						var rows = api.rows({page: 'current'}).nodes();
						var last = null;

						api.column(index, {page: 'current'}).data().each(function (group, i) {
							if (last !== group) {
								var colSpan = (lastTh.data('voting-end')) ? (index + 2) : (index + 1);
								$(rows).eq(i).before(
									'<tr class="group"><td colspan="' + colSpan + '">' + ((group == '') ? 'Noch nicht abgestimmt' : group + ' Stimmen') + '</td></tr>'
								);

								last = group;
							}
						});
					},
					"initComplete": function (settings, json) {
						var oTable = this,
							page = 0,
							api = this.api(),
							firstInit = false;
						if (window.localStorage.getItem(this.attr('id')) !== null) {
							page = parseInt(window.localStorage.getItem(this.attr('id')));
						}
						if (api.page() !== page) {
							oTable.fnPageChange(page);
						}

						$('div.loading').remove();
						$('.dataTables_scrollBody').perfectScrollbar();

						var idList = [];
						votingTable.find('tr[role="row"]').find('td:first-child()').each(function () {
							var self = $(this);

							idList.push(parseInt(self.data('uid')));
						});
						window.localStorage.setItem('voting_id_list', idList);
					}
				});
			}

			$('#tda2017_list,#tda2017_list_jury').find('td').click(function () {
				//glob.debug(dt);
				//glob.debug(dt.page());
			});
		}
		,
		initDataTables: function ($dataTable, $options) {
			var id = $('body').attr('id'),
				idDt = id.substring(1);
			var firstInit = true,
				url = "?id="+idDt+"&type=110";
			if ($('[name="tx_mpmarchitektouren_listprojects[filterOptions][]"]').val() > 0) {
				url = url + '&filter=' + $('[name="tx_mpmarchitektouren_listprojects[filterOptions][]"]').val();
			}

			var colCount = $dataTable.find('th').length,
				colCountArray = [],
				colCountNotIn = [0, 1, 2, 3, 4, 9, 28, 29, 30];
			for (var i = 0; i < colCount; i++) {
				if ($.inArray(i, colCountNotIn) < 0)
					colCountArray.push(i);
			}
			// console.log(colCountArray);

			$options = $options || {
				"ajax": url,
				"deferRender": true,
				"language": {
					"url": "//cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/German.json",
					buttons: {
						colvis: 'Spalten'
					}
				},
				order: [
					[1, 'asc']
				],
				"scrollY": "500px",
				"scrollX": true,
				"scrollCollapse": true,
				"lengthMenu": [
					[10, 25, 50, -1],
					[10, 25, 50, "All"]
				],
				dom: 'Bfrtip',
				buttons: [
					{
						extend: 'excelHtml5',
						title: 'tda2023_liste',
						exportOptions: {
							columns: ':visible'
						}
					},
					{
						extend: 'csvHtml5',
						title: 'tda2023_liste',
						exportOptions: {
							columns: ':visible'
						}
					},
					{
						extend: 'colvis',
						columns: ':not(:first-child)'
					}/*,
					{
						extend: 'colvisGroup',
						text: 'Alle einblenden',
						show: ':hidden'
					},
					{
						extend: 'colvisGroup',
						text: 'Alle ausblenden',
						hide: ':visible:not(:first-child)'
					}*/
				],
				responsive: true,
				columnDefs: [
					{
						orderable: false,
						targets: [0]
					},
					{
						visible: false,
						targets: colCountArray
					}
				]
			};
			// console.log($options);
			if ($dataTable.attr('id') != 'tda2017_list_voting') {
				$options.initComplete = function (settings, json) {
					var oTable = this,
						page = 0,
						api = this.api();
					firstInit = false;
					if (window.localStorage.getItem(this.attr('id')) !== null) {
						page = parseInt(window.localStorage.getItem(this.attr('id')));
					}
					if (api.page() !== page) {
						oTable.fnPageChange(page);
					}

					$('div.loading').remove();
					$('.dataTables_scrollBody').perfectScrollbar();
					if (this.attr('id') != 'tda2017_list_jury')
						PopupLink.init();
				};
				$options.drawCallback = function (settings) {
					var oTable = this,
						page = 0,
						api = this.api();
					if (!firstInit)
						window.localStorage.setItem(this.attr('id'), api.page());
				};
			}

			$dataTable = $dataTable.DataTable($options);
			return $dataTable;
		}
	};

	ProjectHandling = {
		init: function () {
			$('.btn.btn-default.add-employee,.btn.btn-darkgrey.add-employee').click(function ($e) {
				// $e.preventDefault();
				var self = $(this),
					item = self.data('item'),
					selfName = self.attr('name'),
					selfValue = self.val(),
					hiddenField = $('<input id="companyItem' + item + '" type="hidden" name="companyItem" value="' + item + '" />'),
					hiddenField2 = $('<input type="hidden" name="' + selfName + '" value="' + selfValue + '" />'),
					form = self.parents('form'),
					submitButton = form.find('#submit');

				if ($('#companyItem' + item).length == 0) {
					self.before(hiddenField);
					self.before(hiddenField2);
				}
				$('input[name="tx_mpmarchitektouren_project[redirect]"]').val('editAssociates');
				// submitButton.trigger('click');
				//form.submit();
			});

			$('.btn.btn-default.add-wg,.btn.btn-darkgrey.add-wg').click(function ($e) {
				// $e.preventDefault();
				var self = $(this),
					item = self.data('item'),
					selfWg = self.next().data('wguid'),
					selfName = self.next().attr('name'),
					selfValue = self.next().val(),
					// hiddenField = $('<input id="WG-' + item + '" type="hidden" name="tx_mpmarchitektouren_project[wgUid]" value="' + item + '" />'),
					hiddenField2 = $('<input type="hidden" name="' + selfName + '" value="' + selfValue + '" />'),
					form = self.parents('form'),
					submitButton = form.find('#submit');

				// if ($('#companyItem' + item).length == 0) {
				// self.parents('form').append(hiddenField);
				self.parents('form').append(hiddenField2);
				// }
				$('input[name="tx_mpmarchitektouren_project[redirect]"]').val('editArchitects');
				// submitButton.trigger('click');
				//form.submit();
			});

			$('.btn.btn-default.add-wgp,.btn.btn-darkgrey.add-wgp').click(function ($e) {
				// $e.preventDefault();
				var self = $(this),
					item = self.data('item'),
					selfWg = self.next().data('wguid'),
					selfName = self.next().attr('name'),
					selfValue = self.next().val(),
					hiddenField = $('<input id="WG-' + item + '" type="hidden" name="tx_mpmarchitektouren_project[wgUid]" value="' + item + '" />'),
					hiddenField2 = $('<input type="hidden" name="' + selfName + '" value="' + selfValue + '" />'),
					form = self.parents('form'),
					submitButton = form.find('#submit');

				// if ($('#companyItem' + item).length == 0) {
				self.parents('form').append(hiddenField);
				self.parents('form').append(hiddenField2);
				// }
				$('input[name="tx_mpmarchitektouren_project[redirect]"]').val('editArchitects');
				// submitButton.trigger('click');
				//form.submit();
			});

			$('.btn.btn-default.add-builder-partner,.btn.btn-darkgrey.add-builder-partner').click(function ($e) {
				$e.preventDefault();
				var self = $(this),
					item = self.data('item'),
					selfName = self.attr('name'),
					selfValue = self.val(),
					hiddenField = $('<input id="builderItem' + item + '" type="hidden" name="builderItem" value="' + item + '" />'),
					hiddenField2 = $('<input type="hidden" name="' + selfName + '" value="' + selfValue + '" />'),
					form = self.parents('form'),
					submitButton = form.find('#submit');

				if ($('#builderItem' + item).length == 0) {
					self.before(hiddenField);
					self.before(hiddenField2);
				}
				$('input[name="tx_mpmarchitektouren_project[redirect]"]').val('editBuilder');
				submitButton.trigger('click');
				//form.submit();
			});

			$('select.chosen-select[id^=builder]').change(function () {
				var self = $(this),
					selfVal = self.val(),

					fieldsToHide = $('.fieldsToHide'),

					selfId = self.attr('id').replace('builder-', ''),

					selfData = $('#user_' + selfVal);

				if (selfVal == 'leer' || selfVal == '') {
					selfData = $('.useroriginal');
				}

				var userUid = selfData.data('uid'),
					userGender = selfData.data('gender'),
					userFirstname = selfData.data('firstname'),
					userLastname = selfData.data('lastname'),
					userJobtitle = selfData.data('jobtitle'),
					userJobtitleAlt = selfData.data('jobtitle-alt'),
					userTitle = selfData.data('title'),
					userTitleAlt = selfData.data('title-alt'),
					userCertificate = selfData.data('certificate'),
					userCertificateAlt = selfData.data('certificate-alt'),
					userInstitution = selfData.data('institution'),
					userFunction = selfData.data('function'),
					userAddress = selfData.data('address'),
					userZip = selfData.data('zip'),
					userCity = selfData.data('city'),
					userPhone = selfData.data('phone'),
					userFax = selfData.data('fax'),
					userEmail = selfData.data('email'),
					userWww = selfData.data('www'),
					userFacebook = selfData.data('facebook'),
					userInstagram = selfData.data('instagram');


				$('input.form-control[id=firstName-' + selfId + ']').val(userFirstname);
				$('input.form-control[id=lastName-' + selfId + ']').val(userLastname);
				$('input.form-control[id=institution-' + selfId + ']').val(userInstitution);
				$('input.form-control[id=function-' + selfId + ']').val(userFunction);
				$('input.form-control[id=address-' + selfId + ']').val(userAddress);
				$('input.form-control[id=zip-' + selfId + ']').val(userZip);
				$('input.form-control[id=city-' + selfId + ']').val(userCity);
				$('input.form-control[id=phone-' + selfId + ']').val(userPhone);
				$('input.form-control[id=fax-' + selfId + ']').val(userFax);
				$('input.form-control[id=email-' + selfId + ']').val(userEmail);
				$('input.form-control[id=www-' + selfId + ']').val(userWww);
				$('input.form-control[id=facebook-' + selfId + ']').val(userFacebook);
				$('input.form-control[id=instagram-' + selfId + ']').val(userInstagram);

				if (userJobtitle == 'sonstiges')
					$('input.form-control[id=jobtitleAlt-' + selfId + ']').parent('div').stop(true).fadeIn('slow');
				else
					$('input.form-control[id=jobtitleAlt-' + selfId + ']').parent('div').stop(true).fadeOut('fast');
				if (userTitle == 'sonstiges')
					$('input.form-control[id=titleAlt-' + selfId + ']').parent('div').stop(true).fadeIn('slow');
				else
					$('input.form-control[id=titleAlt-' + selfId + ']').parent('div').stop(true).fadeOut('slow');
				if (userCertificate == 'sonstiges')
					$('input.form-control[id=certificateAlt-' + selfId + ']').parent('div').stop(true).fadeIn('slow');
				else
					$('input.form-control[id=certificateAlt-' + selfId + ']').parent('div').stop(true).fadeOut('slow');

				$('select[id^=gender-' + selfId + ']').val(userGender);
				$('select[id^=jobTitle-' + selfId + ']').val(userJobtitle);
				$('select[id^=title-' + selfId + ']').val(userTitle);
				$('select[id^=certificate-' + selfId + ']').val(userCertificate);

				$('.chosen-select').trigger('chosen:updated');
			});

			$('#deleteProject').click(function ($e) {
                $e.preventDefault();
                if (confirm('Wollen Sie das Projekt wirklich löschen?')) {
                    window.location.href = $(this).attr('href');
                }
            });
		}
	};

	PopupLink = {
		init: function () {
			$('.popupLink').each(function () {

				var self = $(this),
					selfId = parseInt(self.attr('id')),
					selfCaption = self.next('.caption'),
					selfCopyright = '',
					selfGallery = false,
					selfIdList = [],
					dataPrint = self.data('print');

				self.click(function ($e) {
					$('#tda').addClass('no-print');
					$e.preventDefault();
					var selfLink = '',

						popupCaption = $('<div class="popup-caption"></div>'),

						popupContainer = $('<div id="popup-container"></div>'),
						popupContainerBg = $('<div id="popup-container-background"></div>'),
						popupContainerContent = $('<div id="popup-container-content"></div>'),
						popupContainerContentInner = $('<div id="popup-container-content-inner"></div>'),
						popupContainerClose = $('<button type="button" class="close" id="popup-container-close" aria-label="Schließen"><span aria-hidden="true">&times;</span></button>'),
						popupContainerPrint = $('<button type="button" class="print" id="popup-container-print" aria-label="Drucken"><span class="glyphicon glyphicon-print" aria-hidden="true"></span></button>'),
						popupContainerPrev = $('<button type="button" class="prev" id="popup-container-prev" aria-label="Vorheriger Artikel"><span class="glyphicon glyphicon-menu-left" aria-hidden="true"></span></button>'),
						popupContainerNext = $('<button type="button" class="next" id="popup-container-next" aria-label="Nächster Artikel"><span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span></button>'),
						body = $('body'),
						maxPopupHeight = $(window).height() - ($(window).height() * 0.3);

					if (selfCaption.length > 0) {
						popupCaption.append(selfCaption.text().trim());
					}

					if (self.is('a')) {
						selfLink = self.attr('href');
						var data = {};

						if (self.data('view') == 'ohne_comment') {
							data = {
								addView: 'ohne'
							}
						}
						$.ajax({
							url: selfLink,
							data: data,
							complete: function ($data) {
								var body = $('body');
								popupContainerContentInner.append($data.responseText);
								popupContainerContent.append(popupContainerContentInner).prepend(popupCaption).prepend(popupContainerClose);
								if (dataPrint) popupContainerContent.prepend(popupContainerPrint);
								popupContainer.append(popupContainerBg).append(popupContainerContent);
								if (body.find('#popup-container').length > 0) {
									$('#popup-container').remove();
								}
								body.append(popupContainer);

								var generatedPopupContainer = body.find('#popup-container');

								generatedPopupContainer.fadeIn('slow', function () {
									$('#popup-container-content-inner').perfectScrollbar();
								});
								PopupLink.initCloseButton(generatedPopupContainer);
								BrowserHandling.init();
							}
						});
					}
					if (self.is('span')) {
						if (self.data('caption')) {
							popupCaption.append(self.data('caption').trim());
						}
						if (self.data('copyright')) {
							selfCopyright = self.data('copyright');
						}
						if (self.data('dark')) {
							popupCaption.addClass('dark');
						}
						if (self.hasClass('helptextShort')) {
							popupContainerContent.css({
								top: '20%',
								left: '30%',
								right: '30%',
								padding: '20px 50px 20px 20px',
								height: self.next().height() + 40,
								maxHeight: maxPopupHeight
							});
							popupContainerContentInner.append(self.next().clone());
						} else {
							selfLink = self.data('href');

							if (self.data('rel')) {
								selfGallery = self.data('rel');
								$('.popupLink[data-rel="' + selfGallery + '"]').each(function () {
									selfIdList.push(parseInt($(this).attr('id')));
								});
							}

							popupContainer.addClass('image');
							popupContainerContentInner.append('<img src="' + selfLink + '" title="' + selfCopyright + '" alt="" style="max-width:100%;" />');
						}

						popupContainerContent.append(popupContainerContentInner);
						popupContainerContent.prepend(popupContainerClose).prepend(popupCaption);
						if (dataPrint) popupContainerContent.prepend(popupContainerPrint);
						popupContainer.append(popupContainerBg).append(popupContainerContent);
						if (body.find('#popup-container').length > 0) {
							//$('#popup-container').remove();
							popupContainer = body.find('#popup-container');
							popupContainer.find('#popup-container-content').remove();
							popupContainerContent.css('display', 'none');
							popupContainer.append(popupContainerContent);
							popupContainer.find('#popup-container-content').fadeIn('slow');
						} else {
							body.append(popupContainer);
						}

						var generatedPopupContainer = body.find('#popup-container');

						generatedPopupContainer.fadeIn('slow', function () {
							if (self.hasClass('helptextShort')) {
								$('#popup-container-content-inner').perfectScrollbar();
								$('#popup-container-content-inner > img').css({
									width: '100%',
									height: 'auto'
								});
							}
							BrowserHandling.init();
						});
						PopupLink.initCloseButton(generatedPopupContainer);

						popupContainer.attr('data-id', self.attr('id'));
						if (selfGallery) {
							popupContainer.attr('data-gallery', true);
							popupContainerContentInner.append(popupContainerPrev).append(popupContainerNext);
						}
					}
					if (self.is('div')) {
						if (self.hasClass('osm')) {
							var mapContainer =
								'<div id="c-popup" class="contentelement-openstreetmaps">' +
								'<div class="embed-responsive embed-responsive-16by9">' +
								'<div id="c-popup-map" class="map"></div>' +
								'</div>' +
								'</div>',
								lng = self.data('lng'),
								lat = self.data('lat');

							popupContainerContentInner.append(mapContainer);
							popupContainerContent.append(popupContainerContentInner);
							popupContainerContent.prepend(popupContainerClose);
							popupContainer.append(popupContainerBg).append(popupContainerContent);
							body.append(popupContainer);

							var generatedPopupContainer = body.find('#popup-container');

							generatedPopupContainer.fadeIn('slow', function () {
								$('#popup-container-content-inner').perfectScrollbar();
								$('#popup-container-content-inner > img').css({
									width: '100%',
									height: 'auto'
								});
								BrowserHandling.init();

								PopupLink.resizeMap();
								$(window).resize(function () {
									PopupLink.resizeMap();
								});
								PopupLink.initPopupMap(lng, lat);
							});
							PopupLink.initCloseButton(generatedPopupContainer);
						}
					}

					if (popupContainer.find('#popup-container-prev').length > 0) {
						var actuallPosition = $.inArray(selfId, selfIdList),
							prevPosition = actuallPosition - 1,
							nextPosition = actuallPosition + 1;
						if (actuallPosition <= 0) {
							prevPosition = selfIdList.length - 1;
						}
						if (actuallPosition >= selfIdList.length) {
							nextPosition = 0;
						}

						$('#popup-container-prev').click(function () {
							generatedPopupContainer.find('#popup-container-content').fadeOut('slow', function () {
								$('#' + selfIdList[prevPosition]).trigger('click');
							});
						});
						$('#popup-container-next').click(function () {
							generatedPopupContainer.find('#popup-container-content').fadeOut('slow', function () {
								$('#' + selfIdList[nextPosition]).trigger('click');
							});
						});
					}
				});
			})
		},
		event: function(){
			document.addEventListener("PopupLink-init", function() {
				PopupLink.init();
			});
		},
		initCloseButton: function (generatedPopupContainer) {
			$('#popup-container-close,#popup-container-background').click(function () {
				generatedPopupContainer.fadeOut('fast', function () {
					$(this).remove();
					$('.no-print').removeClass('no-print');
				});
			});
		},
		initPopupMap: function (lng, lat) {
			OpenLayers.Marker.defaultIcon = function () {
				return new OpenLayers.Icon(OpenLayers.Util.getImageLocation("hs-marker.png"),
					{w: 48, h: 48}, {x: -24, y: -48});
			};

			var mapPopup = new OpenLayers.Map("c-popup-map");
			var mapnik = new OpenLayers.Layer.OSM(
				"OpenStreetMap",
				// Official OSM tileset as protocol-independent URLs
				[
					'//a.tile.openstreetmap.org/${z}/${x}/${y}.png',
					'//b.tile.openstreetmap.org/${z}/${x}/${y}.png',
					'//c.tile.openstreetmap.org/${z}/${x}/${y}.png'
				],
				null);
			var fromProjection = new OpenLayers.Projection("EPSG:4326");   // Transform from WGS 1984
			var toProjection = new OpenLayers.Projection("EPSG:900913"); // to Spherical Mercator Projection
			var position = new OpenLayers.LonLat(lng, lat).transform(fromProjection, toProjection);
			var zoom = 18;
			var markers = new OpenLayers.Layer.Markers("Markers");

			mapPopup.addLayer(markers);
			markers.addMarker(new OpenLayers.Marker(position));
			mapPopup.addLayer(mapnik);
			mapPopup.setCenter(position, zoom);
		},
		resizeMap: function () {
			$('#c-popup').css({
				marginBottom: 0
			});
			$('#c-popup').children('.embed-responsive').css({
				paddingBottom: $('#popup-container-content-inner').height()
			});
		},

		alert: function ($message, $type) {
			if ($('#error-overlay').length > 0) {
				$('#error-overlay').remove();
			}

			var overlay = $('<div id="error-overlay"></div>'),
				messageBox = $('<div id="message-box"><p>' + $message + '</p></div>'),
				okButton = $('<button class="ok btn btn-darkgrey">OK</button>'),
				$return = false;

			switch ($type) {
				case 'info':
					messageBox.addClass('alert-info').attr('role', 'alert').children('p').prepend('<i class="glyphicon glyphicon-info-sign"/>&nbsp;<strong>Information:</strong>&nbsp;');
					$return = 1;
					break;
				case 'warning':
					messageBox.addClass('alert-warning').attr('role', 'alert').children('p').prepend('<i class="glyphicon glyphicon-alert"/>&nbsp;<strong>Warnung:</strong>&nbsp;');
					$return = 2;
					break;
				case 'danger':
					messageBox.addClass('alert-danger').attr('role', 'alert').children('p').prepend('<i class="glyphicon glyphicon-exclamation-sign"/>&nbsp;<strong>Fehler:</strong>&nbsp;');
					$return = 3;
					break;
				default:
					messageBox.addClass('alert-success').attr('role', 'alert');
					break;
			}

			messageBox.append(okButton);
			overlay.append(messageBox);
			$('body').append(overlay);

			$('#error-overlay').find('.ok').click(function () {
				$('#error-overlay').remove();
			});

			return $return;
		}
	};

	BrowserHandling = {
		init: function () {
			$('button.print,a.print').click(function (e) {
				e.preventDefault();
				window.print();
				return false;
			});
		}
	};

	SearchHandling = {
		init: function () {
			let results = $('#kesearch_results');
			if (results.hasClass('noResultsText')) {
				$('#kesearch_filters').hide();
			}
		}
	};

	UserSearchForm = {
		init: function () {
			var usfContainer = $('#ak-userfilter');
			if (usfContainer.length == 0)
				return;
			usfContainer.find('.form-group[data-update="1"] select,.form-group[data-update="1"] input').change(function () {
				UserSearchForm.validateDependencies(usfContainer);
			});
			UserSearchForm.validateDependencies(usfContainer);
			var resultC = usfContainer.find('#resultContainer');
			var resultT = UserSearchForm.initDataTables(usfContainer.find('table.results'));
			usfContainer.find('form').submit(function ($e) {
				var self = $(this);
				$.ajax({
					type: "POST",
					url: self.find('#ajaxURL').val(),
					data: self.find(":input:not(:hidden),select").serializeArray(),
					cache: false,
					async: true,
					success: function ($data) {
						resultC.show();
						resultT.clear();
						resultT.rows.add($data.userData); // Add new data
						resultT.draw();
					},
					error: function ($data) {
						glob.debug($data);
					}
				});
				$e.preventDefault();
				return false;

			});
		},
		initDataTables: function ($dt) {
			var ajaxUrl = $dt.data('ajaxurl');
			$dt = $dt.DataTable({
				columns: [
					{title: "Name"},
					{title: "Fachrichtung"},
					{title: "PLZ"},
					{title: "Ort"}
				],
				// language: {
				// 	"url": "//cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/German.json"
				// },
				"lengthChange": false,
				"dom": '<"top"iflp<"clear">>rt<"bottom"p<"clear">>',
				"oLanguage": {
					"sEmptyTable": "Keine Daten in der Tabelle vorhanden",
					"sInfo": "_TOTAL_ Ergebnisse",
					"sInfoEmpty": "0 bis 0 von 0 Einträgen",
					"sInfoFiltered": "(gefiltert von _MAX_ Einträgen)",
					"sInfoPostFix": "",
					"sInfoThousands": ".",
					"sLengthMenu": "_MENU_ Einträge anzeigen",
					"sLoadingRecords": "Wird geladen...",
					"sProcessing": "Bitte warten...",
					"sSearch": "Suchen",
					"sZeroRecords": "Keine Einträge vorhanden.",
					"oPaginate": {
						"sFirst": "Erste",
						"sNext": '<i class="fa fa-chevron-right" ></i>',
						"sPrevious": '<i class="fa fa-chevron-left" ></i>',
						"sLast": "Letzte"
					},
					"oAria": {
						"sSortAscending": ": aktivieren, um Spalte aufsteigend zu sortieren",
						"sSortDescending": ": aktivieren, um Spalte absteigend zu sortieren"
					}
				},
				order: [[1, 'asc']],
				createdRow: function (row, data, index) {
					$(row).find('td').click(function () {
						UserSearchForm.loadModal(data[4], ajaxUrl);
					})
				}
			});
			return $dt;
		},

		loadModal: function ($uid, $ajaxUrl) {
			var modal = $('#ak-userfilter-modal');
			$.ajax({
				type: "POST",
				url: $ajaxUrl + '&type=778&tx_mpmfeuserdata_akuserfilter[user]=' + $uid,
				data: $uid,
				contentType: "application/x-www-form-urlencoded;charset=UTF-8",
				cache: false,
				async: true,
				success: function ($data) {
					if ($data) {
						modal.html($data);
						modal.modal('show');
						BrowserHandling.init();
					}
				},
				error: function ($data) {
					console.log($data);
				}
			});

		},
		validateDependency: function ($c, $target) {
			var dd = $target.attr('data-depends');
			if (!dd)
				return true;
			var dv = $target.attr('data-depends-value');
			var condition;
			var requirementObject;
			if (dd && dd.indexOf('[]') >= 0) {
				requirementObject = $c.find("input[name='" + dd + "'][value='" + dv + "']");
				condition = requirementObject.is(':checked');
			} else {
				requirementObject = $c.find('select#' + dd);
				condition = requirementObject.val() == dv;
			}
			var requirementFormGroup = requirementObject.parents('.form-group');
			return (condition && UserSearchForm.validateDependency($c, requirementFormGroup));
			//if (condition && UserSearchForm.validateDependency($c, requirementFormGroup))
			//	return true;
			//return false;
		},

		validateDependencies: function ($c) {
			var depending = $c.find('.form-group[data-depends]');

			depending.each(function () {
				var self = $(this);
				if (UserSearchForm.validateDependency($c, self)) {
					self.show();
					self.removeClass('hidden');

				} else {
					self.hide();
					self.addClass('hidden')
				}
			});
		}
	};

	OSM = {
		init: function () {

		},

		initOSM: function ($c, $lng, $lat) {
			$(function () {
				var exists =

					OpenLayers.Marker.defaultIcon = function () {
						return new OpenLayers.Icon(OpenLayers.Util.getImageLocation("hs-marker.png"),
							{w: 48, h: 48}, {x: -24, y: -48});
					};

				$c = new OpenLayers.Map($c);
				var mapnik = new OpenLayers.Layer.OSM(
					"OpenStreetMap",
					// Official OSM tileset as protocol-independent URLs
					[
						'//a.tile.openstreetmap.org/${z}/${x}/${y}.png',
						'//b.tile.openstreetmap.org/${z}/${x}/${y}.png',
						'//c.tile.openstreetmap.org/${z}/${x}/${y}.png'
					],
					null);
				var fromProjection = new OpenLayers.Projection("EPSG:4326");   // Transform from WGS 1984
				var toProjection = new OpenLayers.Projection("EPSG:900913"); // to Spherical Mercator Projection
				var position = new OpenLayers.LonLat($lng, $lat).transform(fromProjection, toProjection);
				var zoom = 18;
				var markers = new OpenLayers.Layer.Markers("Markers");

				$c.addLayer(markers);
				markers.addMarker(new OpenLayers.Marker(position));
				$c.addLayer(mapnik);
				$c.setCenter(position, zoom);
			});
		}
	};

	FUF = {
		init: function () {
			if ($('.fufExtArchProfContent').length > 0) {
				var innerContent = $('.inner-content');

				innerContent.children('.col-md-9').removeClass('col-md-9').addClass('col-md-12');
				innerContent.children('.col-md-3').remove();
			}

			var officeProfileSearchContainer = $('.carousel #office-profile-search'),
				archProf = $('.carousel .archProf');
			//officeProfileSearchContainer.append(archProf);
			//officeProfileSearchContainer.find('h2').remove();

			var steps = officeProfileSearchContainer.find('.form-group'),
				wholeWidth = 0,
				newSearch = $('.carousel .newSearch');

			steps.each(function () {
				var self = $(this);

				wholeWidth += 1220;
			});

			newSearch.width(wholeWidth);
			newSearch.find('.form-group').css('float', 'left');

			var stepNow = 0;

			$('.carousel .nextStep').not('.submit').click(function () {
				var newSearch = $('.carousel .newSearch'),
					newSearchPosition = newSearch.position();
				stepNow++;
				newSearch.animate({
					'margin-left': (stepNow * 1220) * -1
				}, 1000);
			});

			stepNow = 0;

			$('.carousel .prevStep').click(function () {
				var newSearch = $('.carousel .newSearch'),
					newSearchPosition = newSearch.position();
				// console.log('left');
				stepNow--;
				newSearch.animate({
					'margin-left': (stepNow * 1220) * -1
				}, 1000);
			});
		}
	};

	TDA = {
		init: function () {
			$('.load-more.tda').click(function () {
				var self = $(this),
					items = self.data('reload-items'),
					detailPid = self.data('detail-pid'),
					year = self.data('year'),
					offset = $('.tx-mpm-architektouren .selection-box > .csc-default').length;

				var uri = window.location.protocol + '//' + window.location.host;
				var data =
					{
						"id": 928,
						"type": "140",
						"tx_mpmarchitektouren_feprojectlistarchive[detailPid]": detailPid,
						"tx_mpmarchitektouren_feprojectlistarchive[year]": year,
						"tx_mpmarchitektouren_feprojectlistarchive[items]": items,
						"tx_mpmarchitektouren_feprojectlistarchive[offset]": offset,
						"tx_mpmarchitektouren_feprojectlistarchive[ajaxCall]": true
					};

				$.ajax({
					type: "GET",
					dataType: "html",
					url: uri,
					data: data,
					success: function (d) {
						var html = $('<div>').html(d).find('.tx-mpm-architektouren').children().unwrap();

						if (html.length < items) {
							self.after('<div class="alert alert-warning no-more-objects" role="alert"><p><i class="glyphicon glyphicon-warning-sign"/> <span>Keine weiteren Objekte gefunden</span></p></div>');
							self.remove();
							$('.no-more-objects').delay(5000).slideUp('slow');
						}

						$('.selection-box').append(html);
						App.contentElementAnimations();
					}
				});
			});

			$('input#specialSubmit,input#specialSubmit2').click(function ($e) {
				var self = $(this),
					selfName = self.attr('name'),
					selfValue = self.val(),
					selfForm = self.parents('form'),
					hiddenField = $('<input type="hidden" name="' + selfName.replace('addArge', 'specialAction') + '" value="' + selfValue + '"/>');
				selfForm.prepend(hiddenField);
			});

			$('.otherSpecialSubmit').click(function ($e) {
				// $e.preventDefault();
				var self = $(this),
					selfName = self.attr('name'),
					selfValue = self.val(),
					selfForm = self.parents('form'),
					hiddenField = $('<input type="hidden" name="' + selfName + '" value="' + selfValue + '"/>');
				selfForm.append(hiddenField);
			});


			if ($('input[name*="[hasArge]"]').length > 0 && $('input[name*="[addArge]"]').length) {
				if ($('[id^="hasArge"]').first().is(':checked')) {
					$('[name*="[addArge]"]').parent('.btn-group').removeClass('hidden');
				}
				$('[id^="hasArge"]').first().change(function () {
					if ($(this).is(':checked')) {
						$('[name*="[addArge]"]').parent('.btn-group').removeClass('hidden');
					} else {
						$('[name*="[addArge]"]').parent('.btn-group').addClass('hidden');
					}
				});
			}
		}
	}
})
(window, window.document, window.jQuery);